import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SaveIcon from '@mui/icons-material/Save';
import { isNil, set } from 'lodash';
import { configuration, user } from 'apis';
import { useRef, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import SimpleAccordion from 'ui-component/accordion/SimpleAccordion';
import Typography from '@mui/material/Typography';
import * as wjGrid from '@grapecity/wijmo.grid';
import { defaultResultsFieldsMapping } from './constants';
import useChecklistInitialLists from './useChecklistInitialLists';
import useChecklistQueries from './useChecklistQueries';

const ChecklistScreen = () => {
    const checklistTables = useRef();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const seasonGridRef = useRef();
    const seasonBeforeSaveRef = useRef([]);
    const [seasonErrors, setSeasonErrors] = useState({});
    const [seasonList, setSeasonList] = useState([]);
    const [seasonBeforeSave, setSeasonBeforeSave] = useState([]);
    const [seasonValidationMessage, setSeasonValidationMessage] = useState('');
    const [originalSeason, setOriginalSeason] = useState({});
    const [seasonChanges, setSeasonChanges] = useState({});
    const [isSeasonChanged, setIsSeasonChanged] = useState(false);
    const [seasonModalItem, setSeasonModalItem] = useState({});
    const [isSeasonModalOpen, setIsSeasonModalOpen] = useState(false);
    const [seasonDeleteItem, setSeasonDeleteItem] = useState(null);
    const [isSeasonDeleteOpen, setIsSeasonDeleteOpen] = useState(false);

    const applicationTypeGridRef = useRef();
    const hasCapturedApplicationTypeSnapshot = useRef(false);
    const [applicationTypeErrors, setApplicationTypeErrors] = useState({});
    const [applicationTypeList, setApplicationTypeList] = useState([]);
    const [originalApplicationType, setOriginalApplicationType] = useState({});
    const [applicationTypeChanges, setApplicationTypeChanges] = useState({});
    const [isApplicationTypeChanged, setIsApplicationTypeChanged] = useState(false);
    const [applicationTypeListBeforeEdit, setApplicationTypeListBeforeEdit] = useState([]);
    const [applicationTypeValidationMessage, setApplicationTypeValidationMessage] = useState('');
    const [applicationTypeDeleteItem, setApplicationTypeDeleteItem] = useState(null);
    const [isApplicationTypeDeleteOpen, setIsApplicationTypeDeleteOpen] = useState(false);
    const [modalItem, setModalItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const eventsGridRef = useRef();
    const [eventsChanges, setEventsChanges] = useState({});
    const [originalEvents, setOriginalEvents] = useState({});
    const [eventList, setEventList] = useState([]);
    const [isEventChanged, setIsEventChanged] = useState(false);
    const [isEventModalOpen, setIsEventModalOpen] = useState(false);
    const [eventModalItem, setEventModalItem] = useState({});
    const [lastCommittedEvents, setLastCommittedEvents] = useState([]);
    const [eventListBeforeEdit, setEventListBeforeEdit] = useState([]);
    const [eventErrors, setEventErrors] = useState({});
    const [eventValidationMessage, setEventValidationMessage] = useState('');
    const [eventDeleteItem, setEventDeleteItem] = useState(null);
    const [isEventDeleteOpen, setIsEventDeleteOpen] = useState(false);

    const disciplineGridRef = useRef();
    const [disciplineChanges, setdisciplineChanges] = useState({});
    const [originalDiscipline, setOriginaldiscipline] = useState({});
    const [disciplineList, setDisciplineList] = useState([]);
    const [isDisciplineChanged, setIsDisciplineChanged] = useState(false);
    const [isDisciplineModalOpen, setIsDisciplineModalOpen] = useState(false);
    const [disciplineModalItem, setDisciplineModalItem] = useState({});
    const [lastCommittedDiscipline, setLastCommittedDiscipline] = useState([]);
    const [eventDisciplineBeforeEdit, setDisciplineListBeforeEdit] = useState([]);
    const [disciplineErrors, setDisciplineErrors] = useState({});
    const [disciplineValidationMessage, setDisciplineValidationMessage] = useState('');
    const [disciplineDeleteItem, setDisciplineDeleteItem] = useState(null);
    const [isDisciplineDeleteOpen, setIsDisciplineDeleteOpen] = useState(false);

    const [disciplineParents, setDisciplineParents] = useState({});

    const ageCategoryGridRef = useRef();
    const [ageCategoryChanges, setageCategoryChanges] = useState({});
    const [originalAgeCategory, setOriginalIdAgeCategory] = useState({});
    const [ageCategoryList, setageCategoryList] = useState([]);
    const [isAgeCategoryChanged, setIsAgeCategoryChanged] = useState(false);
    const [isAgeCategoryModalOpen, setIsAgeCategoryModalOpen] = useState(false);
    const [AgeCategoryModalItem, setAgeCategoryModalItem] = useState({});
    const [lastCommittedageCategory, setLastCommittedageCategory] = useState([]);
    const [eventAgeCategoryBeforeEdit, setAgeCategoryListBeforeEdit] = useState([]);
    const [ageCategoryErrors, setAgeCategoryErrors] = useState({});

    const divisionGridRef = useRef();
    const [divisionChanges, setdivisionChanges] = useState({});
    const [originalDivision, setOriginalIdDivision] = useState({});
    const [divisionList, setdivisionList] = useState([]);
    const [isDivisionChanged, setIsDivisionChanged] = useState(false);
    const [isDivisionModalOpen, setIsDivisionModalOpen] = useState(false);
    const [DivisionModalItem, setDivisionModalItem] = useState({});
    const [lastCommitteddivision, setLastCommitteddivision] = useState([]);
    const [eventDivisionBeforeEdit, setDivisionListBeforeEdit] = useState([]);
    const [divisionErrors, setDivisionErrors] = useState({});

    const competitionTypeGridRef = useRef();
    const [competitionTypeChanges, setcompetitionTypeChanges] = useState({});
    const [originalCompetitionType, setOriginalIdCompetitionType] = useState({});
    const [competitionTypeList, setcompetitionTypeList] = useState([]);
    const [isCompetitionTypeChanged, setIsCompetitionTypeChanged] = useState(false);
    const [isCompetitionTypeModalOpen, setIsCompetitionTypeModalOpen] = useState(false);
    const [CompetitionTypeModalItem, setCompetitionTypeModalItem] = useState({});
    const [lastCommittedcompetitionType, setLastCommittedcompetitionType] = useState([]);
    const [eventCompetitionTypeBeforeEdit, setCompetitionTypeListBeforeEdit] = useState([]);
    const [competitionTypeErrors, setCompetitionTypeErrors] = useState({});

    const applicationTypeProductAgesGridRef = useRef();
    const [applicationTypeProductAgesList, setApplicationTypeProductAgesList] = useState([]);
    const [applicationTypeProductAgesChanges, setApplicationTypeProductAgesChanges] = useState({});
    const [originalApplicationTypeProductAges, setOriginalApplicationTypeProductAges] = useState({});
    const [isApplicationTypeProductAgesChanged, setIsApplicationTypeProductAgesChanged] = useState(false);
    const [isAppTypeProductAgesModalOpen, setIsAppTypeProductAgesModalOpen] = useState(false);
    const [appTypeProductAgesModalItem, setAppTypeProductAgesModalItem] = useState({});
    const [appTypeProductAgesErrors, setAppTypeProductAgesErrors] = useState({});

    //Application Type Product Service
    const applicationTypeProductServicesGridRef = useRef();
    const [applicationTypeProductServicesList, setApplicationTypeProductServicesList] = useState([]);
    const [isApplicationTypeProductServicesChanged, setIsApplicationTypeProductServicesChanged] = useState(false);
    const [isAppTypeProductServicesModalOpen, setIsAppTypeProductServicesModalOpen] = useState(false);
    const [appTypeProductServicesModalItem, setAppTypeProductServicesModalItem] = useState({});
    const [applicationTypeProductServicesBeforeEdit, setApplicationTypeProductServicesBeforeEdit] = useState([]);
    const [originalApplicationTypeProductServices, setOriginalApplicationTypeProductServices] = useState({});
    const [applicationTypeProductServicesChanges, setApplicationTypeProductServicesChanges] = useState({});
    const [lastCommittedApplicationTypeProductServices, setLastCommittedApplicationTypeProductServices] = useState([]);
    const [appTypeProductServicesErrors, setAppTypeProductServicesErrors] = useState({});

    const [fileTypesList, setFileTypesList] = useState([]);
    const [isFileTypesChanged, setIsFileTypesChanged] = useState(false);
    const [fileTypesChanges, setFileTypesChanges] = useState({});
    const [originalFileTypes, setOriginalFileTypes] = useState({});
    const fileTypesGridRef = useRef();
    const [isFileTypeModalOpen, setIsFileTypeModalOpen] = useState(false);
    const [fileTypeModalItem, setFileTypeModalItem] = useState({});
    const [fileTypesBeforeEdit, setFileTypesBeforeEdit] = useState([]);
    const [hasCapturedFileTypesSnapshot, setHasCapturedFileTypesSnapshot] = useState(false);
    const [fileTypesErrors, setFileTypesErrors] = useState({});

    const optionalAnswersGridRef = useRef();
    const [optionalAnswersList, setOptionalAnswersList] = useState([]);
    const [originalOptionalAnswers, setOriginalOptionalAnswers] = useState({});
    const [optionalAnswerChanges, setOptionalAnswerChanges] = useState({});
    const [isOptionalAnswerChanged, setIsOptionalAnswerChanged] = useState(false);
    const [optionalAnswerModalItem, setOptionalAnswerModalItem] = useState(null);
    const [isOptionalAnswerModalOpen, setIsOptionalAnswerModalOpen] = useState(false);
    const [optionalAnswersBeforeEdit, setOptionalAnswersBeforeEdit] = useState([]);
    const [hasCapturedOptionalAnswerSnapshot, setHasCapturedOptionalAnswerSnapshot] = useState(false);
    const [optionalAnswerErrors, setOptionalAnswerErrors] = useState({});

    const questionsGridRef = useRef();
    const [questionList, setQuestionList] = useState([]);
    const [questionChanges, setQuestionChanges] = useState({});
    const [originalQuestions, setOriginalQuestions] = useState({});
    const [isQuestionChanged, setIsQuestionChanged] = useState(false);
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [questionModalItem, setQuestionModalItem] = useState({});
    const [lastCommittedQuestions, setLastCommittedQuestions] = useState([]);
    const [questionListBeforeEdit, setQuestionListBeforeEdit] = useState([]);
    const [hasCapturedQuestionSnapshot, setHasCapturedQuestionSnapshot] = useState(false);
    const [questionErrors, setQuestionErrors] = useState({});

    const [questionTypes, setQuestionTypes] = useState([]);

    //Product Services
    const [productServicesList, setProductServicesList] = useState([]);
    const [isProductServicesChanged, setIsProductServicesChanged] = useState(false);
    const [productServicesModalItem, setProductServicesModalItem] = useState({});
    const [productServicesBeforeEdit, setProductServicesBeforeEdit] = useState([]);
    const [productServicesChanges, setProductServicesChanges] = useState({});
    const [isProductServicesModalOpen, setIsProductServicesModalOpen] = useState(false);
    const [productServicesErrors, setProductServicesErrors] = useState({});
    const [originalProductServices, setOriginalProductServices] = useState({});

    const productServicesGridRef = useRef();

    const [transactionTypesList, setTransactionTypesList] = useState([]);

    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const confirmResolveRef = useRef(null);
    const [lookupErrorMessage, setLookupErrorMessage] = useState('');
    const [lookupDeleteDialog, setLookupDeleteDialog] = useState({
        open: false,
        message: '',
        itemLabel: '',
        onConfirm: null
    });

    const [disciplines, setDisciplines] = useState([]);

    const [ageCategories, setAgeCategories] = useState([]);

    const {
        eventDataQuery,
        disciplineDataQuery,
        ageCategoryDataQuery,
        divisionDataQuery,
        competitionTypeDataQuery,
        seasonDataQuery,
        applicationTypeProductAgesDataQuery,
        applicationTypeProductServicesDataQuery,
        fileTypesDataQuery,
        applicationTypeDataQuery,
        optionalAnswerDataQuery,
        questionDataQuery
    } = useChecklistQueries();

    useChecklistInitialLists({
        setQuestionTypes,
        setProductServicesList,
        setTransactionTypesList,
        setDisciplines
    });

    const eventDisciplines = disciplines.filter(
        (discipline) => discipline.parentId != null && discipline.parentId !== 'null' && discipline.parentId !== 999
    );

    useEffect(() => {
        if (seasonDataQuery.status === 'success' && Array.isArray(seasonDataQuery.data)) {
            const enriched = seasonDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));

            const deepCopy = JSON.parse(JSON.stringify(enriched));

            setSeasonList(deepCopy);

            if (!seasonBeforeSaveRef.current.length) {
                seasonBeforeSaveRef.current = deepCopy;
            }
        }
    }, [seasonDataQuery.status, seasonDataQuery.data]);

    useEffect(() => {
        if (applicationTypeDataQuery.status === 'success' && Array.isArray(applicationTypeDataQuery.data)) {
            const enriched = applicationTypeDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setApplicationTypeList(enriched);
            setApplicationTypeListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [applicationTypeDataQuery.status, applicationTypeDataQuery.data]);

    useEffect(() => {
        if (eventDataQuery.status === 'success' && Array.isArray(eventDataQuery.data)) {
            const enriched = eventDataQuery.data.map((item) => ({
                ...item,
                nameEn: item.nameEn ?? '',
                abbrEn: item.abbrEn ?? '',
                totalObjects: item.totalObjects ?? 0,
                isTeam: item.isTeam ?? false,
                isCustomDivision: item.isCustomDivision ?? false,
                resultsFieldsMappingJson: item.resultsFieldsMappingJson ?? defaultResultsFieldsMapping,
                isNew: false,
                isDeleted: false
            }));
            setEventList(enriched);
            setEventListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [eventDataQuery.status, eventDataQuery.data]);

    useEffect(() => {
        if (disciplineDataQuery.status === 'success' && Array.isArray(disciplineDataQuery.data)) {
            const enriched = disciplineDataQuery.data.map((item) => ({
                ...item,
                parentId: item.parentId ?? 999,
                isNew: false,
                isDeleted: false
            }));
            setDisciplineList(enriched);

            let parents = enriched.filter((item) => {
                return item.parentId === 999;
            });

            parents = [{ id: 999, name: 'null' }, ...parents];

            setDisciplineParents(parents);

            setDisciplineListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
            setOriginaldiscipline(
                enriched.reduce((acc, item) => {
                    acc[item.id] = { ...item };
                    return acc;
                }, {})
            );
        }
    }, [disciplineDataQuery.status, disciplineDataQuery.data]);

    useEffect(() => {
        if (ageCategoryDataQuery.status === 'success' && Array.isArray(ageCategoryDataQuery.data)) {
            const enriched = ageCategoryDataQuery.data.map((item) => ({
                ...item,
                isCustom: item.isCustom ?? false,
                isNew: false,
                isDeleted: false
            }));
            setageCategoryList(enriched);

            setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [ageCategoryDataQuery.status, ageCategoryDataQuery.data]);

    useEffect(() => {
        if (
            applicationTypeProductAgesDataQuery.status === 'success' &&
            Array.isArray(applicationTypeProductAgesDataQuery.data) &&
            applicationTypeList.length > 0 &&
            productServicesList.length > 0
        ) {
            const enriched = applicationTypeProductAgesDataQuery.data.map((item) => {
                const appType = applicationTypeList.find((a) => Number(a.id) === Number(item.applicationTypeId));
                const prodService = productServicesList.find((p) => Number(p.id) === Number(item.productServiceId));

                return {
                    ...item,
                    validFrom: formatSqlServerDate(item.validFrom),
                    validTo: formatSqlServerDate(item.validTo),
                    applicationTypeTitle: item.applicationTypeDescription || appType?.description || `App#${item.applicationTypeId}`,
                    productServiceTitle: item.productDescription || prodService?.description || `PS#${item.productServiceId}`,
                    isNew: false,
                    isDeleted: false
                };
            });

            setApplicationTypeProductAgesList(enriched);
        }
    }, [
        applicationTypeProductAgesDataQuery.status,
        applicationTypeProductAgesDataQuery.data,
        applicationTypeList,
        productServicesList
    ]);

    useEffect(() => {
        if (divisionDataQuery.status === 'success' && Array.isArray(divisionDataQuery.data)) {
            const enriched = divisionDataQuery.data.map((item) => ({
                ...item,
                value1From: item.value1From ?? null,
                value1To: item.value1To ?? null,
                value2From: item.value2From ?? null,
                value2To: item.value2To ?? null,
                value3From: item.value3From ?? null,
                value3To: item.value3To ?? null,
                isCustom: item.isCustom ?? false,
                isNull: item.isNull ?? false,
                isNew: false,
                isDeleted: false
            }));
            setdivisionList(enriched);

            setDivisionListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [divisionDataQuery.status, divisionDataQuery.data]);

    useEffect(() => {
        if (competitionTypeDataQuery.status === 'success' && Array.isArray(competitionTypeDataQuery.data)) {
            const enriched = competitionTypeDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setcompetitionTypeList(enriched);

            setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [competitionTypeDataQuery.status, competitionTypeDataQuery.data]);

    useEffect(() => {
        if (
            applicationTypeProductServicesDataQuery.status === 'success' &&
            Array.isArray(applicationTypeProductServicesDataQuery.data) &&
            applicationTypeList.length > 0
        ) {
            const enriched = applicationTypeProductServicesDataQuery.data.map((item) => {
                const appType = applicationTypeList.find((a) => Number(a.id) === Number(item.applicationTypeId));
                const prodService = productServicesList.find((p) => Number(p.id) === Number(item.productServiceId));

                return {
                    ...item,
                    id: item.applicationTypeProductServicesId,
                    applicationTypeTitle: appType?.description || `App#${item.applicationTypeId}`,
                    productServiceTitle: prodService?.description || `PS#${item.productServiceId}`,
                    isNew: false,
                    isDeleted: false
                };
            });

            setApplicationTypeProductServicesList(enriched);
            setLastCommittedApplicationTypeProductServices(JSON.parse(JSON.stringify(enriched)));
        }
    }, [
        applicationTypeProductServicesDataQuery.status,
        applicationTypeProductServicesDataQuery.data,
        applicationTypeList,
        productServicesList
    ]);

    useEffect(() => {
        if (fileTypesDataQuery.status === 'success' && Array.isArray(fileTypesDataQuery.data)) {
            const enriched = fileTypesDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setFileTypesList(enriched);
        }
    }, [fileTypesDataQuery.status, fileTypesDataQuery.data]);

    useEffect(() => {
        if (optionalAnswerDataQuery.status === 'success' && Array.isArray(optionalAnswerDataQuery.data)) {
            const enriched = optionalAnswerDataQuery.data.map((item) => {
                const question = questionList.find((q) => q.id === item.questionId);
                return {
                    ...item,
                    isActive: item.isActive ?? true,
                    isDisabled: item.isDisabled ?? false,
                    questionTitle: question?.title ?? `Q#${item.questionId}`,
                    isNew: false,
                    isDeleted: false
                };
            });
            setOptionalAnswersList(enriched);
        }
    }, [optionalAnswerDataQuery.status, optionalAnswerDataQuery.data, questionList]);

    useEffect(() => {
        if (questionDataQuery.status === 'success' && Array.isArray(questionDataQuery.data)) {
            const enriched = questionDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setQuestionList(enriched);
        }
    }, [questionDataQuery.status, questionDataQuery.data]);

    const confirmSave = () => {
        return new Promise((resolve) => {
            confirmResolveRef.current = resolve;
            setIsConfirmOpen(true);
        });
    };

    const getChecklistErrorMessage = (err, fallback) => {
        const data = err?.response?.data ?? err;

        if (Array.isArray(data?.details) && data.details.length) {
            return data.details.join('\n');
        }

        return data?.message || data?.Message || err?.message || fallback;
    };

    const showLookupError = (message) => {
        setLookupErrorMessage(message);
    };

    const openLookupDeleteDialog = ({ message, itemLabel, onConfirm }) => {
        setLookupDeleteDialog({
            open: true,
            message,
            itemLabel,
            onConfirm
        });
    };

    const closeLookupDeleteDialog = () => {
        setLookupDeleteDialog({
            open: false,
            message: '',
            itemLabel: '',
            onConfirm: null
        });
    };

    const handleLookupDeleteConfirm = async () => {
        const onConfirm = lookupDeleteDialog.onConfirm;
        closeLookupDeleteDialog();

        if (!onConfirm) return;

        try {
            await onConfirm();
        } catch (err) {
            console.error('Delete failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('DeleteFailed', { defaultValue: 'Η διαγραφή απέτυχε.' })));
        }
    };

    const buttonSx = {
        minWidth: 120,
        height: 36,
        fontSize: 14,
        textTransform: 'none'
    };

    const renderLookupToolbar = ({ onAdd, onDelete, onSave, isChanged }) => (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {onAdd && (
                <Button
                    variant="contained"
                    onClick={onAdd}
                    startIcon={<AddIcon />}
                    sx={{ ...buttonSx, backgroundColor: '#2196f3', color: '#fff', boxShadow: 2 }}
                >
                    {t('Add', { defaultValue: 'Προσθήκη' })}
                </Button>
            )}
            {onDelete && (
                <Button variant="outlined" color="error" onClick={onDelete} startIcon={<DeleteIcon />} sx={buttonSx}>
                    {t('Delete', { defaultValue: 'Διαγραφή' })}
                </Button>
            )}
            {isChanged && onSave && (
                <Button variant="contained" color="success" onClick={onSave} startIcon={<SaveIcon />} sx={{ ...buttonSx, minWidth: 130 }}>
                    {t('Save', { defaultValue: 'Αποθήκευση' })}
                </Button>
            )}
        </div>
    );

    const getSelectedGridItem = (gridRef) => {
        const grid = gridRef.current;
        if (!grid) return null;

        grid.finishEditing();
        return grid.collectionView?.currentItem ?? null;
    };

    const handleConfirmResponse = (confirmed) => {
        setIsConfirmOpen(false);
        if (confirmResolveRef.current) {
            confirmResolveRef.current(confirmed);
            confirmResolveRef.current = null;
        }
    };

    const formatSqlServerDate = (value) => {
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            const year = value.getFullYear();
            const month = String(value.getMonth() + 1).padStart(2, '0');
            const day = String(value.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        if (typeof value === 'string') {
            const trimmed = value.trim();
            const datePart = /^(\d{4}-\d{2}-\d{2})T/.exec(trimmed);
            return datePart ? datePart[1] : trimmed;
        }

        return typeof value === 'string' ? value.trim() : value;
    };

    const getSqlServerDateParts = (value) => {
        const normalized = formatSqlServerDate(value);
        if (typeof normalized !== 'string') return null;

        const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalized);
        if (!match) return null;

        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const date = new Date(Date.UTC(year, month - 1, day));

        if (
            year < 1 ||
            year > 9999 ||
            date.getUTCFullYear() !== year ||
            date.getUTCMonth() !== month - 1 ||
            date.getUTCDate() !== day
        ) {
            return null;
        }

        return { year, month, day, time: date.getTime() };
    };

    const isValidSqlServerDate = (value) => !!getSqlServerDateParts(value);
    const isBlankDate = (value) => value == null || value === '';
    const isValidOptionalSqlServerDate = (value) => isBlankDate(value) || isValidSqlServerDate(value);
    const parseNullableNumber = (value) => (value == null || value === '' ? null : Number(value));
    const parseNullableInteger = (value) => (value == null || value === '' ? null : Number(value));

    const getInvalidSqlServerDateMessage = (fieldName) =>
        t('InvalidSqlServerDate', {
            fieldName,
            defaultValue: `Παρακαλώ βάλτε έγκυρη ημερομηνία στο πεδίο ${fieldName} σε μορφή YYYY-MM-DD.`
        });

    const showSeasonValidationMessage = (message) => {
        setSeasonValidationMessage(message);
    };

    /*###############################################
  ############# LK Season #########################
  ###############################################*/
    const initializeSeason = (flex) => {
        seasonGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalSeason(originalData);

        flex.cellEditEnding.addHandler((s, e) => {
            const editedField = s.columns[e.col].binding;
            if (!['dateFrom', 'dateTo'].includes(editedField)) return;

            const editedValue = s.activeEditor?.value;
            if (!isValidSqlServerDate(editedValue)) {
                e.cancel = true;
                showSeasonValidationMessage(getInvalidSqlServerDateMessage(editedField === 'dateFrom' ? 'Έναρξη' : 'Λήξη'));
            }
        });

        flex.cellEditEnded.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            const editedValue = editedItem[editedField];

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setSeasonList((prev) =>
                    prev.map((item) => {
                        const isSameItem = editedItem.id != null ? item.id === editedItem.id : item === editedItem;
                        return isSameItem ? { ...item, ...editedItem } : item;
                    })
                );
                setIsSeasonChanged(true);
            }
        });
    };

    const handleAddSeason = () => {
        setSeasonBeforeSave(JSON.parse(JSON.stringify(seasonList)));
        setSeasonModalItem({
            id: null,
            description: '',
            abbr: '',
            dateFrom: '',
            dateTo: '',
            position: 0,
            dataKey: '',
            isActive: true,
            comments: '',
            isNew: true,
            isDeleted: false
        });
        setIsSeasonModalOpen(true);
    };

    const buildSeasonPayloadItem = (item) => ({
        ...item,
        id: typeof item.id === 'number' ? item.id : 0,
        description: item.description?.trim() ?? '',
        abbr: item.abbr?.trim() ?? '',
        dateFrom: formatSqlServerDate(item.dateFrom),
        dateTo: formatSqlServerDate(item.dateTo),
        position: item.position ?? 0,
        dataKey: item.dataKey?.trim() ?? '',
        isActive: item.isActive ?? true,
        comments: item.comments?.trim() ?? '',
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const hasSeasonPendingChanges = (items) =>
        items.some((item) => {
            if (item.isDeleted || item.isNew || !item.id) return true;

            const originalItem = originalSeason[item.id];
            if (!originalItem) return false;

            return ['description', 'abbr', 'dateFrom', 'dateTo', 'position', 'dataKey', 'isActive', 'comments'].some(
                (field) => (item[field] ?? '') !== (originalItem[field] ?? '')
            );
        });

    const handleDeleteSeason = () => {
        const grid = seasonGridRef.current;
        if (!grid) return;

        grid.finishEditing();

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setSeasonDeleteItem(selected);
        setIsSeasonDeleteOpen(true);
    };

    const confirmDeleteSeason = async () => {
        if (!seasonDeleteItem) return;

        try {
            if (seasonDeleteItem.isNew || !seasonDeleteItem.id) {
                setSeasonList((prev) => {
                    const next = prev.filter((item) => item !== seasonDeleteItem);
                    setIsSeasonChanged(hasSeasonPendingChanges(next));
                    return next;
                });
            } else {
                const deleteSource = originalSeason[seasonDeleteItem.id] ?? seasonDeleteItem;
                await configuration.postSeason([buildSeasonPayloadItem({ ...deleteSource, isDeleted: true })]);
                await seasonDataQuery.refetch();
                setIsSeasonChanged(false);
            }

            setSeasonDeleteItem(null);
            setIsSeasonDeleteOpen(false);
        } catch (err) {
            console.error('Delete failed:', err);
            setSeasonDeleteItem(null);
            setIsSeasonDeleteOpen(false);
            showSeasonValidationMessage(getChecklistErrorMessage(err, t('DeleteFailed', { defaultValue: 'Η διαγραφή απέτυχε.' })));
        }
    };

    const validateSeasonItem = (item) => {
        const errors = {};

        if (!item.description || item.description.trim() === '') {
            errors.description = 'Description is required.';
        } else if (item.description.length > 200) {
            errors.description = 'Max 200 characters.';
        }

        if (!item.abbr || item.abbr.trim() === '') {
            errors.abbr = 'Abbreviation is required.';
        } else if (item.abbr.length > 20) {
            errors.abbr = 'Max 20 characters.';
        }

        const dateFromParts = getSqlServerDateParts(item.dateFrom);
        const dateToParts = getSqlServerDateParts(item.dateTo);

        if (!dateFromParts) {
            errors.dateFrom = getInvalidSqlServerDateMessage('Έναρξη');
        }

        if (!dateToParts) {
            errors.dateTo = getInvalidSqlServerDateMessage('Λήξη');
        } else if (dateFromParts && dateFromParts.time > dateToParts.time) {
            errors.dateTo = 'Η λήξη πρέπει να είναι μετά ή ίδια με την έναρξη.';
        }

        if (item.position == null || isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        if (item.dataKey && item.dataKey.length > 100) {
            errors.dataKey = 'Max 100 characters.';
        }

        return errors;
    };

    const handleSeasonModalSave = () => {
        const validationErrors = validateSeasonItem(seasonModalItem);
        setSeasonErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setSeasonList((prev) => {
            const isEdit = seasonModalItem.id !== null && !seasonModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === seasonModalItem.id ? { ...seasonModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...seasonModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsSeasonChanged(true);
        setIsSeasonModalOpen(false);
        setSeasonErrors({});
    };

    const handleSaveSeason = async () => {
        if (seasonGridRef.current && !seasonGridRef.current.finishEditing()) {
            return;
        }

        const validationErrors = seasonList
            .filter((item) => !item.isDeleted)
            .flatMap((item, index) => {
                const errors = validateSeasonItem(item);
                return Object.values(errors).map((message) => `Γραμμή ${index + 1}: ${message}`);
            });

        if (validationErrors.length > 0) {
            showSeasonValidationMessage(validationErrors.join('\n'));
            return;
        }

        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const cleanList = seasonList.map(buildSeasonPayloadItem);

            await configuration.postSeason(cleanList);
            await seasonDataQuery.refetch();

            // seasonBeforeSaveRef.current = JSON.parse(JSON.stringify(cleanList));
            setIsSeasonChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showSeasonValidationMessage(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    const trackChanges = (gridRef, setChanges, setChanged, originalData) => {
        const grid = gridRef.current;

        grid.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            if (editedField === 'isActive') {
                editedValue = s.activeEditor.checked;
            }

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setChanges((prevChanges) => {
                    const updatedChanges = { ...prevChanges };
                    updatedChanges[editedItem.id] = {
                        ...editedItem,
                        [editedField]: editedValue
                    };
                    return updatedChanges;
                });
                setChanged(true);
            }
        });
    };

    /*###############################################
  ############# LK Application Type ###############
  ###############################################*/

    const initializeApplicationType = (flex) => {
        applicationTypeGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalApplicationType(originalData);

        flex.cellEditEnded.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            const newValue = editedItem[editedField];
            const originalValue = originalData[editedItem.id]?.[editedField];

            if (newValue !== originalValue) {
                setApplicationTypeList((prev) =>
                    prev.map((item) => {
                        const isSameItem = editedItem.id != null ? item.id === editedItem.id : item === editedItem;
                        return isSameItem ? { ...item, ...editedItem } : item;
                    })
                );
                setApplicationTypeChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: newValue
                    }
                }));

                setIsApplicationTypeChanged(true);
            }
        });
    };

    const validateApplicationTypeItem = (item) => {
        const errors = {};

        if (item.id == null || isNaN(item.id)) {
            errors.id = 'Id must be a number.';
        } else if (item.id < 0) {
            errors.id = 'Id must be a positive number.';
        }

        if (!item.description || item.description.trim() === '') {
            errors.description = 'Description is required.';
        } else if (item.description.length > 200) {
            errors.description = 'Max 200 characters.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.copyFiles_DataKey && item.copyFiles_DataKey.length > 50) {
            errors.copyFiles_DataKey = 'CopyFiles DataKey must be 50 characters or less.';
        }

        if (item.dataKey && item.dataKey.length > 100) {
            errors.dataKey = 'DataKey must be 100 characters or less.';
        }

        if (item.renderOptions && item.renderOptions.length > 500) {
            errors.renderOptions = 'Render Options must be 500 characters or less.';
        }

        if (item.comments && item.comments.length > 500) {
            errors.comments = 'Comments must be 500 characters or less.';
        }

        if (item.position == null || isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const showApplicationTypeValidationMessage = (message) => {
        setApplicationTypeValidationMessage(message);
    };

    const buildApplicationTypePayloadItem = (item) => {
        const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

        return {
            id: Number(item.id) || 0,
            description: sanitize(item.description, 200),
            abbr: sanitize(item.abbr, 50),
            hint: sanitize(item.hint),
            copyFiles_DataKey: sanitize(item.copyFiles_DataKey, 50),
            dataKey: sanitize(item.dataKey, 100),
            renderOptions: sanitize(item.renderOptions, 500),
            concernAthlete: item.concernAthlete ?? false,
            concernOfficial: item.concernOfficial ?? false,
            concernOrganization: item.concernOrganization ?? false,
            isNewAction: item.isNewAction ?? false,
            isEditAction: item.isEditAction ?? false,
            copyFiles: item.copyFiles ?? true,
            reqKeyB4Submit: item.reqKeyB4Submit ?? false,
            isActive: item.isActive ?? false,
            comments: sanitize(item.comments, 500),
            position: item.position ?? 0,
            isNew: item.isNew ?? false,
            isDeleted: item.isDeleted ?? false
        };
    };

    const hasApplicationTypePendingChanges = (items) =>
        items.some((item) => {
            if (item.isDeleted || item.isNew || !item.id) return true;

            const originalItem = originalApplicationType[item.id];
            if (!originalItem) return false;

            return [
                'description',
                'abbr',
                'hint',
                'position',
                'concernAthlete',
                'concernOfficial',
                'concernOrganization',
                'isNewAction',
                'isEditAction',
                'copyFiles',
                'copyFiles_DataKey',
                'dataKey',
                'isActive',
                'comments',
                'reqKeyB4Submit',
                'renderOptions'
            ].some((field) => (item[field] ?? '') !== (originalItem[field] ?? ''));
        });

    const handleApplicationTypeModalSave = () => {
        const validationErrors = validateApplicationTypeItem(modalItem);
        setApplicationTypeErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return; // prevent save if any errors
        }

        setApplicationTypeList((prev) => {
            const isEdit = modalItem.id !== null && !modalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === modalItem.id ? { ...modalItem, isNew: false } : item));
            } else {
                return [...prev, { ...modalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsApplicationTypeChanged(true);
        setIsModalOpen(false);
        setApplicationTypeErrors({});
    };

    const handleAddApplicationType = () => {
        setApplicationTypeListBeforeEdit(JSON.parse(JSON.stringify(applicationTypeList)));

        setModalItem({
            id: null,
            description: '',
            abbr: '',
            hint: '',
            position: 0,
            concernAthlete: false,
            concernOfficial: false,
            concernOrganization: false,
            isNewAction: false,
            isEditAction: false,
            copyFiles: true,
            copyFiles_DataKey: '',
            dataKey: '',
            isActive: true,
            comments: '',
            reqKeyB4Submit: false,
            renderOptions: '',
            isNew: true,
            isDeleted: false
        });
        setIsModalOpen(true);
    };

    const handleDeleteApplicationType = () => {
        const grid = applicationTypeGridRef.current;
        if (!grid) return;

        grid.finishEditing();

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setApplicationTypeDeleteItem(selected);
        setIsApplicationTypeDeleteOpen(true);
    };

    const confirmDeleteApplicationType = async () => {
        if (!applicationTypeDeleteItem) return;

        try {
            if (applicationTypeDeleteItem.isNew || !applicationTypeDeleteItem.id) {
                setApplicationTypeList((prev) => {
                    const next = prev.filter((item) => item !== applicationTypeDeleteItem);
                    setIsApplicationTypeChanged(hasApplicationTypePendingChanges(next));
                    return next;
                });
            } else {
                const deleteSource = originalApplicationType[applicationTypeDeleteItem.id] ?? applicationTypeDeleteItem;
                await configuration.postApplicationType([
                    buildApplicationTypePayloadItem({ ...deleteSource, isDeleted: true })
                ]);
                await applicationTypeDataQuery.refetch();

                setApplicationTypeChanges({});
                setOriginalApplicationType({});
                setIsApplicationTypeChanged(false);
                hasCapturedApplicationTypeSnapshot.current = false;
            }

            setApplicationTypeDeleteItem(null);
            setIsApplicationTypeDeleteOpen(false);
        } catch (err) {
            console.error('Delete failed:', err);
            setApplicationTypeDeleteItem(null);
            setIsApplicationTypeDeleteOpen(false);
            showApplicationTypeValidationMessage(getChecklistErrorMessage(err, t('DeleteFailed', { defaultValue: 'Η διαγραφή απέτυχε.' })));
        }
    };

    const handleSaveApplicationType = async () => {
        if (applicationTypeGridRef.current && !applicationTypeGridRef.current.finishEditing()) {
            return;
        }

        const validationErrors = applicationTypeList
            .filter((item) => !item.isDeleted)
            .flatMap((item, index) => {
                const errors = validateApplicationTypeItem(item);
                return Object.values(errors).map((message) => `Γραμμή ${index + 1}: ${message}`);
            });

        if (validationErrors.length > 0) {
            showApplicationTypeValidationMessage(validationErrors.join('\n'));
            return;
        }

        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const cleanList = applicationTypeList.map(buildApplicationTypePayloadItem);

            await configuration.postApplicationType(cleanList);
            await applicationTypeDataQuery.refetch();

            setApplicationTypeChanges({});
            setOriginalApplicationType({});
            setIsApplicationTypeChanged(false);
            hasCapturedApplicationTypeSnapshot.current = false;
        } catch (err) {
            console.error('Save failed:', err);
            showApplicationTypeValidationMessage(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ############# LK Events ###############
  ###############################################*/

    const initializeEvents = (flex) => {
        eventsGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalEvents(originalData);

        flex.cellEditEnded.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            const editedValue = editedItem[editedField];

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setEventList((prev) =>
                    prev.map((item) => {
                        const isSameItem = editedItem.id != null ? item.id === editedItem.id : item === editedItem;
                        return isSameItem ? { ...item, ...editedItem } : item;
                    })
                );
                setEventsChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsEventChanged(true);
            }
        });
    };

    const validateEventItem = (item) => {
        const errors = {};

        if (item.code == null || isNaN(item.code)) {
            errors.code = 'Code is required and must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.nameEn && item.nameEn.length > 100) {
            errors.nameEn = 'NameEn must be 100 characters or less.';
        }

        if (item.abbrEn && item.abbrEn.length > 50) {
            errors.abbrEn = 'AbbrEn must be 50 characters or less.';
        }

        if (!item.disciplineId || isNaN(item.disciplineId)) {
            errors.disciplineId = 'Discipline is required.';
        }

        if (item.totalAthletes != null && isNaN(item.totalAthletes)) {
            errors.totalAthletes = 'Total Athletes must be a number.';
        }

        if (item.totalObjects != null && isNaN(item.totalObjects)) {
            errors.totalObjects = 'Total Objects must be a number.';
        }

        return errors;
    };

    const showEventValidationMessage = (message) => {
        setEventValidationMessage(message);
    };

    const buildEventPayloadItem = (item) => ({
        id: item.id ?? 0,
        code: item.code ?? 0,
        name: typeof item.name === 'string' ? item.name.trim().substring(0, 100) : '',
        abbr: typeof item.abbr === 'string' ? item.abbr.trim().substring(0, 50) : '',
        nameEn: typeof item.nameEn === 'string' ? item.nameEn.trim().substring(0, 100) : '',
        abbrEn: typeof item.abbrEn === 'string' ? item.abbrEn.trim().substring(0, 50) : '',
        totalAthletes: item.totalAthletes ?? 0,
        totalObjects: item.totalObjects ?? 0,
        isTeam: item.isTeam ?? false,
        isCustomDivision: item.isCustomDivision ?? false,
        isActive: item.isActive ?? true,
        disciplineId: Number(item.disciplineId) || 0,
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false,
        resultsFieldsMappingJson: item.resultsFieldsMappingJson ?? defaultResultsFieldsMapping
    });

    const hasEventPendingChanges = (items) =>
        items.some((item) => {
            if (item.isDeleted || item.isNew || !item.id) return true;

            const originalItem = originalEvents[item.id];
            if (!originalItem) return false;

            return [
                'code',
                'name',
                'abbr',
                'nameEn',
                'abbrEn',
                'totalAthletes',
                'totalObjects',
                'isTeam',
                'isCustomDivision',
                'isActive',
                'disciplineId',
                'resultsFieldsMappingJson'
            ].some((field) => (item[field] ?? '') !== (originalItem[field] ?? ''));
        });

    const handleAddEvent = () => {
        setEventListBeforeEdit(JSON.parse(JSON.stringify(eventList)));
        setEventModalItem({
            id: null,
            code: 0,
            name: '',
            abbr: '',
            nameEn: '',
            abbrEn: '',
            totalAthletes: 0,
            totalObjects: 0,
            isTeam: false,
            isCustomDivision: false,
            isActive: true,
            disciplineId: '',
            isNew: true,
            isDeleted: false,
            resultsFieldsMappingJson: defaultResultsFieldsMapping
        });
        setIsEventModalOpen(true);
    };

    const handleDeleteEvent = () => {
        const grid = eventsGridRef.current;
        if (!grid) return;

        grid.finishEditing();

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setEventDeleteItem(selected);
        setIsEventDeleteOpen(true);
    };

    const confirmDeleteEvent = async () => {
        if (!eventDeleteItem) return;

        try {
            if (eventDeleteItem.isNew || !eventDeleteItem.id) {
                setEventList((prev) => {
                    const next = prev.filter((item) => item !== eventDeleteItem);
                    setIsEventChanged(hasEventPendingChanges(next));
                    return next;
                });
            } else {
                const deleteSource = originalEvents[eventDeleteItem.id] ?? eventDeleteItem;
                await configuration.postEvents([buildEventPayloadItem({ ...deleteSource, isDeleted: true })]);
                await eventDataQuery.refetch();

                setEventsChanges({});
                setOriginalEvents({});
                setIsEventChanged(false);
            }

            setEventDeleteItem(null);
            setIsEventDeleteOpen(false);
        } catch (err) {
            console.error('Delete failed:', err);
            setEventDeleteItem(null);
            setIsEventDeleteOpen(false);
            showEventValidationMessage(getChecklistErrorMessage(err, t('DeleteFailed', { defaultValue: 'Η διαγραφή απέτυχε.' })));
        }
    };

    const handleEventModalSave = () => {
        const validationErrors = validateEventItem(eventModalItem);
        setEventErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setEventList((prev) => {
            const isEdit = eventModalItem.id !== null && !eventModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === eventModalItem.id ? { ...eventModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...eventModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsEventChanged(true);
        setIsEventModalOpen(false);
        setEventErrors({});
    };

    const handleSaveEvent = async () => {
        if (eventsGridRef.current && !eventsGridRef.current.finishEditing()) {
            return;
        }

        const validationErrors = eventList
            .filter((item) => !item.isDeleted)
            .flatMap((item, index) => {
                const errors = validateEventItem(item);
                return Object.values(errors).map((message) => `Γραμμή ${index + 1}: ${message}`);
            });

        if (validationErrors.length > 0) {
            showEventValidationMessage(validationErrors.join('\n'));
            return;
        }

        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const cleanList = eventList.map(buildEventPayloadItem);

            await configuration.postEvents(cleanList);
            await eventDataQuery.refetch();

            setEventsChanges({});
            setOriginalEvents({});
            setIsEventChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showEventValidationMessage(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ############# LK Discipline ###############
  ###############################################*/

    const initializeDiscipline = (flex) => {
        disciplineGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginaldiscipline(originalData);

        flex.cellEditEnded.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            const editedValue = editedItem[editedField];

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setDisciplineList((prev) =>
                    prev.map((item) => {
                        const isSameItem = editedItem.id != null ? item.id === editedItem.id : item === editedItem;
                        return isSameItem ? { ...item, ...editedItem } : item;
                    })
                );
                setdisciplineChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsDisciplineChanged(true);
            }
        });
    };

    const validateDisciplineItem = (item) => {
        const errors = {};

        if (item.id == null || isNaN(item.id) || Number(item.id) <= 0) {
            errors.id = 'Id is required and must be a positive number.';
        }

        if (item.parentId != null && item.parentId !== 999 && isNaN(item.parentId)) {
            errors.parentId = 'ParentId must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 20) {
            errors.abbr = 'Abbr must be 20 characters or less.';
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        if (item.comments && item.comments.length > 500) {
            errors.comments = 'Comments must be 500 characters or less.';
        }

        if (item.dataKey && item.dataKey.length > 100) {
            errors.dataKey = 'DataKey must be 100 characters or less.';
        }

        return errors;
    };

    const showDisciplineValidationMessage = (message) => {
        setDisciplineValidationMessage(message);
    };

    const buildDisciplinePayloadItem = (item) => ({
        id: item.id ?? 0,
        parentId: item.parentId && item.parentId !== 'null' && item.parentId !== 999 ? Number(item.parentId) : null,
        description: typeof item.name === 'string' ? item.name.trim().substring(0, 100) : '',
        abbr: typeof item.abbr === 'string' ? item.abbr.trim().substring(0, 20) : '',
        position: Number(item.position) || 0,
        dataKey: typeof item.dataKey === 'string' ? item.dataKey.trim().substring(0, 100) : null,
        isActive: item.isActive ?? true,
        comments: typeof item.comments === 'string' ? item.comments.trim() : '',
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const hasDisciplinePendingChanges = (items) =>
        items.some((item) => {
            if (item.isDeleted || item.isNew || !item.id) return true;

            const originalItem = originalDiscipline[item.id];
            if (!originalItem) return false;

            return ['parentId', 'name', 'abbr', 'position', 'dataKey', 'isActive', 'comments'].some(
                (field) => (item[field] ?? '') !== (originalItem[field] ?? '')
            );
        });

    const handleAddDiscipline = () => {
        setDisciplineListBeforeEdit(JSON.parse(JSON.stringify(disciplineList)));
        setDisciplineModalItem({
            id: null,
            parentId: 999,
            name: '',
            abbr: '',
            position: 0,
            dataKey: '',
            isActive: true,
            comments: '',
            isNew: true,
            isDeleted: false
        });
        setIsDisciplineModalOpen(true);
    };

    const handleDeleteDiscipline = () => {
        const grid = disciplineGridRef.current;
        if (!grid) return;

        grid.finishEditing();

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setDisciplineDeleteItem(selected);
        setIsDisciplineDeleteOpen(true);
    };

    const confirmDeleteDiscipline = async () => {
        if (!disciplineDeleteItem) return;

        try {
            if (disciplineDeleteItem.isNew || !disciplineDeleteItem.id) {
                setDisciplineList((prev) => {
                    const next = prev.filter((item) => item !== disciplineDeleteItem);
                    setIsDisciplineChanged(hasDisciplinePendingChanges(next));
                    return next;
                });
            } else {
                const deleteSource = originalDiscipline[disciplineDeleteItem.id] ?? disciplineDeleteItem;
                await configuration.postDisciplines([buildDisciplinePayloadItem({ ...deleteSource, isDeleted: true })]);
                await disciplineDataQuery.refetch();

                setdisciplineChanges({});
                setOriginaldiscipline({});
                setIsDisciplineChanged(false);
            }

            setDisciplineDeleteItem(null);
            setIsDisciplineDeleteOpen(false);
        } catch (err) {
            console.error('Delete failed:', err);
            setDisciplineDeleteItem(null);
            setIsDisciplineDeleteOpen(false);
            showDisciplineValidationMessage(getChecklistErrorMessage(err, t('DeleteFailed', { defaultValue: 'Η διαγραφή απέτυχε.' })));
        }
    };

    const handleDisciplineModalSave = () => {
        const validationErrors = validateDisciplineItem(disciplineModalItem);
        setDisciplineErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setDisciplineList((prev) => {
            const isEdit = disciplineModalItem.id !== null && !disciplineModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === disciplineModalItem.id ? { ...disciplineModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...disciplineModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsDisciplineChanged(true);
        setIsDisciplineModalOpen(false);
        setDisciplineErrors({});
    };

    const handleSaveDiscipline = async () => {
        if (disciplineGridRef.current && !disciplineGridRef.current.finishEditing()) {
            return;
        }

        const validationErrors = disciplineList
            .filter((item) => !item.isDeleted)
            .flatMap((item, index) => {
                const errors = validateDisciplineItem(item);
                return Object.values(errors).map((message) => `Γραμμή ${index + 1}: ${message}`);
            });

        if (validationErrors.length > 0) {
            showDisciplineValidationMessage(validationErrors.join('\n'));
            return;
        }

        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const cleanList = disciplineList.map(buildDisciplinePayloadItem);

            await configuration.postDisciplines(cleanList);
            await disciplineDataQuery.refetch();

            setdisciplineChanges({});
            setOriginaldiscipline({});
            setIsDisciplineChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showDisciplineValidationMessage(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ############# LK AgeCategories ###############
  ###############################################*/

    const initializeAgeCategory = (flex) => {
        ageCategoryGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdAgeCategory(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(ageCategoryList)));
                    hasCapturedBeforeEdit = true;
                }

                setageCategoryChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsAgeCategoryChanged(true);
            }
        });
    };

    const ageCategoryFieldLabels = {
        code: 'Code',
        name: 'Όνομα',
        abbr: 'Abbr',
        gender: 'Gender',
        ageFrom: 'AgeFrom',
        ageTo: 'AgeTo',
        rAgeFrom: 'RAgeFrom',
        rAgeTo: 'RAgeTo',
        position: 'Θέση'
    };

    const validateAgeCategoryItem = (item) => {
        const errors = {};

        if (item.code == null || item.code === '' || isNaN(Number(item.code))) {
            errors.code = 'είναι υποχρεωτικό και πρέπει να είναι αριθμός.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'είναι υποχρεωτικό.';
        } else if (item.name.length > 100) {
            errors.name = 'πρέπει να είναι έως 100 χαρακτήρες.';
        }

        if (item.ageFrom != null && item.ageFrom !== '' && isNaN(Number(item.ageFrom))) {
            errors.ageFrom = 'πρέπει να είναι αριθμός.';
        }

        if (item.ageTo != null && item.ageTo !== '' && isNaN(Number(item.ageTo))) {
            errors.ageTo = 'πρέπει να είναι αριθμός.';
        }

        if (item.rAgeTo != null && item.rAgeTo !== '' && isNaN(Number(item.rAgeTo))) {
            errors.rAgeTo = 'πρέπει να είναι αριθμός.';
        }

        if (item.rAgeFrom != null && item.rAgeFrom !== '' && isNaN(Number(item.rAgeFrom))) {
            errors.rAgeFrom = 'πρέπει να είναι αριθμός.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'πρέπει να είναι έως 50 χαρακτήρες.';
        }

        if (item.gender && item.gender.length !== 1) {
            errors.gender = 'πρέπει να είναι ένας χαρακτήρας.';
        }

        if (item.position != null && item.position !== '' && isNaN(Number(item.position))) {
            errors.position = 'πρέπει να είναι αριθμός.';
        }

        return errors;
    };

    const getAgeCategoryValidationMessages = (items) =>
        items
            .filter((item) => !item.isDeleted)
            .flatMap((item, index) => {
                const errors = validateAgeCategoryItem(item);
                const rowLabel = item.id ? `Γραμμή ${index + 1} (Id ${item.id})` : `Γραμμή ${index + 1}`;

                return Object.entries(errors).map(
                    ([field, message]) => `${rowLabel} - ${ageCategoryFieldLabels[field] ?? field}: ${message}`
                );
            });

    const handleAddAgeCategory = () => {
        setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(ageCategoryList)));
        setAgeCategoryModalItem({
            code: null,
            name: '',
            abbr: '',
            gender: 'X',
            ageFrom: null,
            ageTo: null,
            rAgeFrom: null,
            rAgeTo: null,
            position: null,
            isActive: true,
            isCustom: false,
            isNew: true,
            isDeleted: false
        });
        setIsAgeCategoryModalOpen(true);
    };

    const buildAgeCategoryPayloadItem = (item) => {
        const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

        return {
            id: item.id ?? 0,
            code: item.code ?? 0,
            name: sanitize(item.name, 100),
            abbr: sanitize(item.abbr, 50),
            gender: sanitize(item.gender, 1),
            ageFrom: item.ageFrom,
            ageTo: item.ageTo,
            rAgeFrom: item.rAgeFrom,
            rAgeTo: item.rAgeTo,
            position: item.position ?? 0,
            isActive: item.isActive ?? true,
            isCustom: item.isCustom ?? false,
            isNew: item.isNew ?? false,
            isDeleted: item.isDeleted ?? false
        };
    };

    const handleDeleteAgeCategory = () => {
        const selected = getSelectedGridItem(ageCategoryGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteAgeCategoryQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη ηλικιακή κατηγορία;'
            }),
            itemLabel: selected.name,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setageCategoryList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                const deleteSource = originalAgeCategory[selected.id] ?? selected;
                await configuration.postAgeCategories([buildAgeCategoryPayloadItem({ ...deleteSource, isDeleted: true })]);
                await ageCategoryDataQuery.refetch();
                setageCategoryChanges({});
                setOriginalIdAgeCategory({});
                setIsAgeCategoryChanged(false);
            }
        });
    };

    const handleAgeCategoryModalSave = () => {
        const validationErrors = validateAgeCategoryItem(AgeCategoryModalItem);
        setAgeCategoryErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setageCategoryList((prev) => {
            const isEdit = AgeCategoryModalItem.id !== null && !AgeCategoryModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === AgeCategoryModalItem.id ? { ...AgeCategoryModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...AgeCategoryModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsAgeCategoryChanged(true);
        setIsAgeCategoryModalOpen(false);
        setAgeCategoryErrors({});
    };

    const handleSaveAgeCategory = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            ageCategoryGridRef.current?.finishEditing();
            const validationMessages = getAgeCategoryValidationMessages(ageCategoryList);
            if (validationMessages.length > 0) {
                showLookupError(validationMessages.join('\n'));
                return;
            }

            const cleanList = ageCategoryList.map(buildAgeCategoryPayloadItem);

            await configuration.postAgeCategories(cleanList);
            await ageCategoryDataQuery.refetch();

            setageCategoryChanges({});
            setOriginalIdAgeCategory({});
            setIsAgeCategoryChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ############# LK Divisions ###############
  ###############################################*/

    const initializeDivision = (flex) => {
        divisionGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdDivision(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setDivisionListBeforeEdit(JSON.parse(JSON.stringify(divisionList)));
                    hasCapturedBeforeEdit = true;
                }

                setdivisionChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsDivisionChanged(true);
            }
        });
    };

    const validateDivisionItem = (item) => {
        const errors = {};

        if (item.disciplineId == null || item.disciplineId === '' || isNaN(Number(item.disciplineId))) {
            errors.disciplineId = 'DisciplineId is required and must be a number.';
        }

        if (item.eventId != null && item.eventId !== '' && isNaN(Number(item.eventId))) {
            errors.eventId = 'EventId must be a number.';
        }

        if (item.ageCategoryId != null && item.ageCategoryId !== '' && isNaN(Number(item.ageCategoryId))) {
            errors.ageCategoryId = 'AgeCategoryId must be a number.';
        }

        if (item.competitionTypeId != null && item.competitionTypeId !== '' && isNaN(Number(item.competitionTypeId))) {
            errors.competitionTypeId = 'CompetitionTypeId must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.position != null && item.position !== '' && isNaN(Number(item.position))) {
            errors.position = 'Position must be a number.';
        }

        ['value1From', 'value1To', 'value2From', 'value2To'].forEach((field) => {
            if (item[field] != null && item[field] !== '' && isNaN(Number(item[field]))) {
                errors[field] = `${field} must be a number.`;
            }
        });

        ['value3From', 'value3To'].forEach((field) => {
            const value = item[field];
            if (value != null && value !== '') {
                const numericValue = Number(value);
                if (isNaN(numericValue) || !Number.isInteger(numericValue)) {
                    errors[field] = `${field} must be an integer.`;
                }
            }
        });

        return errors;
    };

    const handleAddDivision = () => {
        setDivisionListBeforeEdit(JSON.parse(JSON.stringify(divisionList)));
        setDivisionModalItem({
            disciplineId: null,
            eventId: null,
            ageCategoryId: null,
            competitionTypeId: null,
            name: '',
            abbr: '',
            position: null,
            value1From: null,
            value1To: null,
            value2From: null,
            value2To: null,
            value3From: null,
            value3To: null,
            isCustom: false,
            isNull: false,
            isNew: true,
            isDeleted: false
        });
        setIsDivisionModalOpen(true);
    };

    const buildDivisionPayloadItem = (item) => ({
        id: item.id ?? 0,
        disciplineId: parseNullableNumber(item.disciplineId) ?? 0,
        eventId: parseNullableNumber(item.eventId),
        competitionTypeId: parseNullableNumber(item.competitionTypeId),
        ageCategoryId: parseNullableNumber(item.ageCategoryId),
        name: typeof item.name === 'string' ? item.name.trim().substring(0, 100) : '',
        abbr: typeof item.abbr === 'string' ? item.abbr.trim().substring(0, 50) : '',
        position: parseNullableNumber(item.position),
        value1From: parseNullableNumber(item.value1From),
        value1To: parseNullableNumber(item.value1To),
        value2From: parseNullableNumber(item.value2From),
        value2To: parseNullableNumber(item.value2To),
        value3From: parseNullableInteger(item.value3From),
        value3To: parseNullableInteger(item.value3To),
        isCustom: item.isCustom ?? false,
        isNull: item.isNull ?? false,
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const handleDeleteDivision = () => {
        const selected = getSelectedGridItem(divisionGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteDivisionQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη κατηγορία;'
            }),
            itemLabel: selected.name,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setdivisionList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                const deleteSource = originalDivision[selected.id] ?? selected;
                await configuration.postDivisions([buildDivisionPayloadItem({ ...deleteSource, isDeleted: true })]);
                await divisionDataQuery.refetch();
                setdivisionChanges({});
                setOriginalIdDivision({});
                setIsDivisionChanged(false);
            }
        });
    };

    const handleDivisionModalSave = () => {
        const validationErrors = validateDivisionItem(DivisionModalItem);
        setDivisionErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setdivisionList((prev) => {
            const isEdit = DivisionModalItem.id !== null && !DivisionModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === DivisionModalItem.id ? { ...DivisionModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...DivisionModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsDivisionChanged(true);
        setIsDivisionModalOpen(false);
        setDivisionErrors({});
    };

    const handleSaveDivision = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            divisionGridRef.current?.finishEditing();
            const invalidItem = divisionList.find((item) => !item.isDeleted && Object.keys(validateDivisionItem(item)).length > 0);
            if (invalidItem) {
                showLookupError(t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' }));
                return;
            }

            const cleanList = divisionList.map(buildDivisionPayloadItem);

            await configuration.postDivisions(cleanList);
            await divisionDataQuery.refetch();

            setdivisionChanges({});
            setOriginalIdDivision({});
            setIsDivisionChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ############# LK CompetitionTypes ###############
  ###############################################*/

    const initializeCompetitionTypes = (flex) => {
        competitionTypeGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdCompetitionType(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(competitionTypeList)));
                    hasCapturedBeforeEdit = true;
                }

                setcompetitionTypeChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsCompetitionTypeChanged(true);
            }
        });
    };

    const validateCompetitionTypeItem = (item) => {
        const errors = {};

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 15) {
            errors.abbr = 'Abbr must be 15 characters or less.';
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleAddCompetitionType = () => {
        setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(competitionTypeList)));
        setCompetitionTypeModalItem({
            name: '',
            abbr: '',
            position: null,
            isActive: true,
            comments: '',
            isNew: true,
            isDeleted: false
        });
        setIsCompetitionTypeModalOpen(true);
    };

    const buildCompetitionTypePayloadItem = (item) => ({
        id: item.id ?? 0,
        description: typeof item.name === 'string' ? item.name.trim().substring(0, 100) : item.description ?? '',
        abbr: typeof item.abbr === 'string' ? item.abbr.trim().substring(0, 50) : '',
        position: item.position,
        comments: item.comments,
        isActive: item.isActive,
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const handleDeleteCompetitionType = () => {
        const selected = getSelectedGridItem(competitionTypeGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteCompetitionTypeQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε τον επιλεγμένο τύπο διαγωνισμού;'
            }),
            itemLabel: selected.name,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setcompetitionTypeList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                const deleteSource = originalCompetitionType[selected.id] ?? selected;
                await configuration.postCompetitionTypes([buildCompetitionTypePayloadItem({ ...deleteSource, isDeleted: true })]);
                await competitionTypeDataQuery.refetch();
                setcompetitionTypeChanges({});
                setOriginalIdCompetitionType({});
                setIsCompetitionTypeChanged(false);
            }
        });
    };

    const handleCompetitionTypeModalSave = () => {
        const validationErrors = validateCompetitionTypeItem(CompetitionTypeModalItem);
        setCompetitionTypeErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setcompetitionTypeList((prev) => {
            const isEdit = CompetitionTypeModalItem.id !== null && !CompetitionTypeModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === CompetitionTypeModalItem.id ? { ...CompetitionTypeModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...CompetitionTypeModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsCompetitionTypeChanged(true);
        setIsCompetitionTypeModalOpen(false);
        setCompetitionTypeErrors({});
    };

    const handleSaveCompetitionType = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            competitionTypeGridRef.current?.finishEditing();
            const invalidItem = competitionTypeList.find(
                (item) => !item.isDeleted && Object.keys(validateCompetitionTypeItem(item)).length > 0
            );
            if (invalidItem) {
                showLookupError(t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' }));
                return;
            }

            const cleanList = competitionTypeList.map(buildCompetitionTypePayloadItem);

            await configuration.postCompetitionTypes(cleanList);
            await competitionTypeDataQuery.refetch();

            setcompetitionTypeChanges({});
            setOriginalIdCompetitionType({});
            setIsCompetitionTypeChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ######### Application Type Product Ages #########
  ###############################################*/

    const initializeApplicationTypeProductAges = (flex) => {
        applicationTypeProductAgesGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalApplicationTypeProductAges(originalData);

        trackChanges(
            applicationTypeProductAgesGridRef,
            setApplicationTypeProductAgesChanges,
            setIsApplicationTypeProductAgesChanged,
            originalData
        );
    };

    const validateApplicationTypeProductAgeItem = (item) => {
        const errors = {};

        if (!item.applicationTypeId || isNaN(Number(item.applicationTypeId))) {
            errors.applicationTypeId = 'Application Type is required.';
        }

        if (!item.productServiceId || isNaN(Number(item.productServiceId))) {
            errors.productServiceId = 'Product Service is required.';
        }

        ['fromAge', 'toAge'].forEach((field) => {
            if (item[field] != null && item[field] !== '') {
                const value = Number(item[field]);
                if (isNaN(value) || !Number.isInteger(value)) {
                    errors[field] = `${field} must be an integer.`;
                }
            }
        });

        if (item.unitPrice != null && item.unitPrice !== '' && isNaN(Number(item.unitPrice))) {
            errors.unitPrice = 'Unit Price must be a valid number.';
        } else if (Number(item.unitPrice) < 0) {
            errors.unitPrice = 'Unit Price must be a positive number.';
        }

        if (!isValidOptionalSqlServerDate(item.validFrom)) {
            errors.validFrom = getInvalidSqlServerDateMessage('Valid From');
        }

        if (!isValidOptionalSqlServerDate(item.validTo)) {
            errors.validTo = getInvalidSqlServerDateMessage('Valid To');
        }

        const validFromParts = getSqlServerDateParts(item.validFrom);
        const validToParts = getSqlServerDateParts(item.validTo);
        if (validFromParts && validToParts && validFromParts.time > validToParts.time) {
            errors.validTo = 'Valid To must be after Valid From.';
        }

        return errors;
    };

    const handleAddApplicationTypeProductAge = () => {
        setAppTypeProductAgesModalItem({
            id: null,
            applicationTypeId: null,
            productServiceId: null,
            fromAge: null,
            toAge: null,
            unitPrice: 0,
            validFrom: '',
            validTo: '',
            isActive: true,
            isNew: true,
            isDeleted: false
        });
        setAppTypeProductAgesErrors({});
        setIsAppTypeProductAgesModalOpen(true);
    };

    const buildApplicationTypeProductAgePayloadItem = (item) => ({
        id: item.id ?? '00000000-0000-0000-0000-000000000000',
        applicationTypeId: parseNullableInteger(item.applicationTypeId) ?? 0,
        productServiceId: parseNullableInteger(item.productServiceId) ?? 0,
        transTypeId: parseNullableInteger(item.transTypeId) ?? 20,
        applicationStatusId: parseNullableInteger(item.applicationStatusId) ?? 25,
        personStatusId: parseNullableInteger(item.personStatusId) ?? 200,
        genderId: parseNullableInteger(item.genderId),
        fromAge: parseNullableInteger(item.fromAge),
        toAge: parseNullableInteger(item.toAge),
        validFrom: isBlankDate(item.validFrom) ? null : formatSqlServerDate(item.validFrom),
        validTo: isBlankDate(item.validTo) ? null : formatSqlServerDate(item.validTo),
        unitPrice: parseNullableNumber(item.unitPrice) ?? 0,
        vatPerc: parseNullableNumber(item.vatPerc) ?? 0,
        isActive: item.isActive ?? true,
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const handleDeleteApplicationTypeProductAge = () => {
        const selected = getSelectedGridItem(applicationTypeProductAgesGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteApplicationTypeProductAgeQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη χρέωση ηλικίας τύπου αίτησης;'
            }),
            itemLabel: `${selected.applicationTypeTitle ?? ''} ${selected.productServiceTitle ?? ''}`.trim(),
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setApplicationTypeProductAgesList((prev) => prev.filter((item) => item !== selected));
                    setIsApplicationTypeProductAgesChanged(true);
                    return;
                }

                const deleteSource = originalApplicationTypeProductAges[selected.id] ?? selected;
                await configuration.postApplicationTypeProductAges([
                    buildApplicationTypeProductAgePayloadItem({ ...deleteSource, isDeleted: true })
                ]);
                await applicationTypeProductAgesDataQuery.refetch();
                setApplicationTypeProductAgesChanges({});
                setOriginalApplicationTypeProductAges({});
                setIsApplicationTypeProductAgesChanged(false);
            }
        });
    };

    const handleApplicationTypeProductAgeModalSave = () => {
        const validationErrors = validateApplicationTypeProductAgeItem(appTypeProductAgesModalItem);
        setAppTypeProductAgesErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const appType = applicationTypeList.find((a) => Number(a.id) === Number(appTypeProductAgesModalItem.applicationTypeId));
        const prodService = productServicesList.find((p) => Number(p.id) === Number(appTypeProductAgesModalItem.productServiceId));

        const enrichedItem = {
            ...appTypeProductAgesModalItem,
            applicationTypeTitle: appType?.description || `App#${appTypeProductAgesModalItem.applicationTypeId}`,
            productServiceTitle: prodService?.description || `PS#${appTypeProductAgesModalItem.productServiceId}`,
            isNew: appTypeProductAgesModalItem.isNew ?? true,
            isDeleted: false
        };

        setApplicationTypeProductAgesList((prev) => [...prev, enrichedItem]);
        setIsApplicationTypeProductAgesChanged(true);
        setIsAppTypeProductAgesModalOpen(false);
        setAppTypeProductAgesErrors({});
    };

    const handleApplicationTypeProductAges = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const grid = applicationTypeProductAgesGridRef.current;
            grid?.finishEditing();

            const items = applicationTypeProductAgesList;
            const invalidItem = items.find(
                (item) => !item.isDeleted && Object.keys(validateApplicationTypeProductAgeItem(item)).length > 0
            );

            if (invalidItem) {
                showLookupError(
                    t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' })
                );
                return;
            }

            const cleanList = items.map(buildApplicationTypeProductAgePayloadItem);

            await configuration.postApplicationTypeProductAges(cleanList);
            await applicationTypeProductAgesDataQuery.refetch();
            setApplicationTypeProductAgesChanges({});
            setOriginalApplicationTypeProductAges({});
            setIsApplicationTypeProductAgesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ######### Application Type Product Services #########
  ###############################################*/

    const initializeApplicationTypeProductServices = (flex) => {
        applicationTypeProductServicesGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalApplicationTypeProductServices(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setApplicationTypeProductServicesBeforeEdit(JSON.parse(JSON.stringify(applicationTypeProductServicesList)));
                    hasCapturedBeforeEdit = true;
                }

                setApplicationTypeProductServicesChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsApplicationTypeProductServicesChanged(true);
            }
        });
    };

    const validateProductServiceItem = (item) => {
        const errors = {};

        if (item.applicationTypeId == null || isNaN(item.applicationTypeId)) {
            errors.applicationTypeId = 'Application Type is required.';
        } else if (item.applicationTypeId < 0) {
            errors.applicationTypeId = 'Id must be a positive number';
        }

        if (!item.productServiceId || isNaN(item.productServiceId)) {
            errors.productServiceId = 'Product Service is required.';
        }

        if (!item.transTypeId || isNaN(item.transTypeId)) {
            errors.transTypeId = 'Transaction Type is required.';
        }

        if (item.unitPrice != null && isNaN(item.unitPrice)) {
            errors.unitPrice = 'Unit Price must be a valid number.';
        } else if (item.unitPrice < 0) {
            errors.unitPrice = 'Unit Price must be a positive number';
        }

        if (item.vatPerc != null && isNaN(item.vatPerc)) {
            errors.vatPerc = 'VAT must be a valid number.';
        } else if (item.vatPerc < 0) {
            errors.vatPerc = 'Vat must be a positive number';
        }

        if (item.validFrom && item.validTo && new Date(item.validFrom) > new Date(item.validTo)) {
            errors.validTo = 'Valid To must be after Valid From.';
        }

        if (!isValidOptionalSqlServerDate(item.validFrom)) {
            errors.validFrom = getInvalidSqlServerDateMessage('Valid From');
        }

        if (!isValidOptionalSqlServerDate(item.validTo)) {
            errors.validTo = getInvalidSqlServerDateMessage('Valid To');
        }

        return errors;
    };

    const handleAddApplicationTypeProductService = () => {
        setApplicationTypeProductServicesBeforeEdit(JSON.parse(JSON.stringify(applicationTypeProductServicesList)));
        setAppTypeProductServicesModalItem({
            id: null,
            applicationTypeId: null,
            productServiceId: null,
            applicationAuditStatusId: null,
            personAuditStatusId: null,
            transTypeId: null,
            validFrom: '',
            validTo: '',
            unitPrice: null,
            vatPerc: null,
            isActive: true,
            isNew: true,
            isDeleted: false
        });
        setIsAppTypeProductServicesModalOpen(true);
    };

    const buildApplicationTypeProductServicePayloadItem = (item) => ({
        id: item.id ?? 0,
        applicationTypeId: item.applicationTypeId ?? 0,
        productServiceId: item.productServiceId ?? 0,
        applicationAuditStatusId: item.applicationAuditStatusId ?? null,
        personAuditStatusId: item.personAuditStatusId ?? null,
        transTypeId: item.transTypeId ?? 1,
        unitPrice: parseFloat(item.unitPrice) || 0,
        vatPerc: parseFloat(item.vatPerc) || 0,
        validFrom: isBlankDate(item.validFrom) ? null : formatSqlServerDate(item.validFrom),
        validTo: isBlankDate(item.validTo) ? null : formatSqlServerDate(item.validTo),
        isActive: item.isActive ?? true,
        applicationStatusId: item.applicationStatusId ?? null,
        personStatusId: item.personStatusId ?? null,
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const handleDeleteApplicationTypeProductService = () => {
        const selected = getSelectedGridItem(applicationTypeProductServicesGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteApplicationTypeProductServiceQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη υπηρεσία τύπου αίτησης;'
            }),
            itemLabel: `${selected.applicationTypeTitle ?? ''} ${selected.productServiceTitle ?? ''}`.trim(),
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setApplicationTypeProductServicesList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                const deleteSource = originalApplicationTypeProductServices[selected.id] ?? selected;
                await configuration.postApplicationTypeProductServices([
                    buildApplicationTypeProductServicePayloadItem({ ...deleteSource, isDeleted: true })
                ]);
                await applicationTypeProductServicesDataQuery.refetch();
                setApplicationTypeProductServicesChanges({});
                setOriginalApplicationTypeProductServices({});
                setIsApplicationTypeProductServicesChanged(false);
            }
        });
    };

    const handleApplicationTypeProductServiceModalSave = () => {
        const validationErrors = validateProductServiceItem(appTypeProductServicesModalItem);
        setAppTypeProductServicesErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const appType = applicationTypeList.find((a) => a.id === appTypeProductServicesModalItem.applicationTypeId);
        const prodService = productServicesList.find((p) => p.id === appTypeProductServicesModalItem.productServiceId);

        const enrichedItem = {
            ...appTypeProductServicesModalItem,
            applicationTypeTitle: appType?.description || `App#${appTypeProductServicesModalItem.applicationTypeId}`,
            productServiceTitle: prodService?.description || `PS#${appTypeProductServicesModalItem.productServiceId}`,
            isNew: appTypeProductServicesModalItem.isNew ?? true,
            isDeleted: false
        };

        setApplicationTypeProductServicesList((prev) => {
            const isEdit = enrichedItem.id !== null && !enrichedItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === enrichedItem.id ? enrichedItem : item));
            } else {
                return [...prev, enrichedItem];
            }
        });

        setIsApplicationTypeProductServicesChanged(true);
        setIsAppTypeProductServicesModalOpen(false);
        setAppTypeProductServicesErrors({});
    };

    const handleSaveApplicationTypeProductServices = async () => {
        try {
            const confirmed = await confirmSave();
            if (!confirmed) return;
            applicationTypeProductServicesGridRef.current?.finishEditing();
            const invalidItem = applicationTypeProductServicesList.find(
                (item) => !item.isDeleted && Object.keys(validateProductServiceItem(item)).length > 0
            );
            if (invalidItem) {
                showLookupError(t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' }));
                return;
            }

            const cleanList = applicationTypeProductServicesList.map(buildApplicationTypeProductServicePayloadItem);

            await configuration.postApplicationTypeProductServices(cleanList);
            await applicationTypeProductServicesDataQuery.refetch();

            setApplicationTypeProductServicesChanges({});
            setOriginalApplicationTypeProductServices({});
            setIsApplicationTypeProductServicesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ################ Product Services ###############
  ###############################################*/

    const initializeProductServices = (flex) => {
        productServicesGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalProductServices(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setProductServicesBeforeEdit(JSON.parse(JSON.stringify(productServicesList)));
                    hasCapturedBeforeEdit = true;
                }

                setProductServicesChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsProductServicesChanged(true);
            }
        });
    };

    const handleAddProductService = () => {
        setProductServicesBeforeEdit(JSON.parse(JSON.stringify(productServicesList)));

        const newItem = {
            id: null,
            description: '',
            abbr: '',
            code: '',
            unitPrice: 0,
            vatPerc: 0,
            position: 0,
            dataKey: '',
            hasSeason: false,
            isActive: true,
            isUniquePerEntity: false,
            pfeTypeId: null,
            isPayment: false,
            parentID: null,
            isDefault: false,
            isNew: true,
            isDeleted: false
        };

        setProductServicesModalItem(newItem);
        setIsProductServicesModalOpen(true);
    };

    const buildProductServicePayloadItem = (item) => ({
        id: item.id ?? 0,
        description: item.description || '',
        abbr: item.abbr || '',
        code: item.code || '',
        unitPrice: parseFloat(item.unitPrice) || 0,
        vatPerc: parseFloat(item.vatPerc) || 0,
        position: item.position ?? 0,
        dataKey: item.dataKey ?? '',
        hasSeason: item.hasSeason ?? false,
        isActive: item.isActive ?? true,
        pfeTypeId: item.pfeTypeId ?? null,
        isPayment: item.isPayment ?? false,
        parentID: item.parentID ?? null,
        isDefault: item.isDefault ?? false,
        isUniquePerEntity: item.isUniquePerEntity ?? false,
        isNew: item.isNew ?? false,
        isDeleted: item.isDeleted ?? false
    });

    const handleDeleteProductService = () => {
        const selected = getSelectedGridItem(productServicesGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteProductServiceQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη υπηρεσία προϊόντος;'
            }),
            itemLabel: selected.description,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setProductServicesList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                const deleteSource = originalProductServices[selected.id] ?? selected;
                await configuration.postProductServices([buildProductServicePayloadItem({ ...deleteSource, isDeleted: true })]);
                const refreshed = await configuration.getProductServices();
                setProductServicesList(refreshed.map((p) => ({ ...p, isNew: false, isDeleted: false })));
                setProductServicesChanges({});
                setOriginalProductServices({});
                setIsProductServicesChanged(false);
            }
        });
    };

    const handleSaveProductServices = async () => {
        try {
            const confirmed = await confirmSave();
            if (!confirmed) return;
            productServicesGridRef.current?.finishEditing();

            const cleanList = productServicesList.map(buildProductServicePayloadItem);

            await configuration.postProductServices(cleanList);
            const refreshed = await configuration.getProductServices();
            setProductServicesList(refreshed.map((p) => ({ ...p, isNew: false, isDeleted: false })));

            setProductServicesChanges({});
            setOriginalProductServices({});
            setIsProductServicesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    const handleProductServicesModalSave = () => {
        const updatedList = [...productServicesList];
        const index = updatedList.findIndex((p) => p.id === productServicesModalItem.id);

        if (index > -1) {
            // Update existing
            updatedList[index] = { ...productServicesModalItem };
        } else {
            // Add new
            updatedList.push(productServicesModalItem);
        }

        setProductServicesList(updatedList);
        setIsProductServicesChanged(true);
        setIsProductServicesModalOpen(false);
    };

    /*###############################################
  ################ LK File Types##################
  ###############################################*/

    const initializeFileTypes = (flex) => {
        fileTypesGridRef.current = flex;
        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalFileTypes(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalFileTypes[editedItem.id]?.[editedField];
            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setFileTypesBeforeEdit(JSON.parse(JSON.stringify(fileTypesList)));
                    hasCapturedBeforeEdit = true;
                }

                setFileTypesChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsFileTypesChanged(true);
            }
        });
    };

    const validateFileTypeItem = (item) => {
        const errors = {};

        if (!item.code || item.code.trim() === '') {
            errors.code = 'Code is required.';
        } else if (item.code.length > 20) {
            errors.code = 'Max 20 characters.';
        }

        if (!item.descr || item.descr.trim() === '') {
            errors.descr = 'Description is required.';
        } else if (item.descr.length > 100) {
            errors.descr = 'Max 100 characters.';
        }

        if (item.abbr && item.abbr.length > 20) {
            errors.abbr = 'Abbr must be 20 characters or less.';
        }

        if (item.dataKey && item.dataKey.length > 50) {
            errors.dataKey = 'DataKey must be 50 characters or less.';
        }

        if (item.tableRef && item.tableRef.length > 50) {
            errors.tableRef = 'TableRef must be 50 characters or less.';
        }

        if (item.comments && item.comments.length > 500) {
            errors.comments = 'Comments must be 500 characters or less.';
        }

        if (item.templates && item.templates.length > 500) {
            errors.templates = 'Templates must be 500 characters or less.';
        }

        const lblFields = ['lblDateFrom', 'lblDateTo', 'lblIssuedAt', 'lblIssuedBy', 'lblNumber', 'lblComments'];
        for (const field of lblFields) {
            if (item[field] && item[field].length > 50) {
                errors[field] = `${field} must be 50 characters or less.`;
            }
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleAddFileType = () => {
        setFileTypesBeforeEdit(JSON.parse(JSON.stringify(fileTypesList)));
        setFileTypeModalItem({
            id: null,
            code: '',
            descr: '',
            abbr: '',
            dataKey: '',
            tableRef: '',
            position: 1,
            isActive: true,
            comments: '',
            lblDateFrom: '',
            lblDateTo: '',
            lblIssuedAt: '',
            lblIssuedBy: '',
            lblNumber: '',
            lblComments: '',
            lkCommonParentId: null,
            pfeTypeId: null,
            copyToPF: false,
            templates: '',
            isNew: true,
            isDeleted: false
        });
        setIsFileTypeModalOpen(true);
    };

    const buildFileTypePayloadItem = (item) => {
        const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

        return {
            id: item.id ?? 0,
            code: sanitize(item.code, 20),
            descr: sanitize(item.descr, 100),
            abbr: sanitize(item.abbr, 20),
            dataKey: sanitize(item.dataKey, 50),
            tableRef: sanitize(item.tableRef, 50),
            position: item.position ?? 1,
            isActive: item.isActive ?? true,
            comments: sanitize(item.comments, 500),
            lblDateFrom: sanitize(item.lblDateFrom, 50),
            lblDateTo: sanitize(item.lblDateTo, 50),
            lblIssuedAt: sanitize(item.lblIssuedAt, 50),
            lblIssuedBy: sanitize(item.lblIssuedBy, 50),
            lblNumber: sanitize(item.lblNumber, 50),
            lblComments: sanitize(item.lblComments, 50),
            lkCommonParentId: item.lkCommonParentId ?? null,
            pfeTypeId: item.pfeTypeId ?? null,
            copyToPF: item.copyToPF ?? false,
            templates: sanitize(item.templates, 500),
            isNew: item.isNew ?? false,
            isDeleted: item.isDeleted ?? false
        };
    };

    const handleDeleteFileType = () => {
        const selected = getSelectedGridItem(fileTypesGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteFileTypeQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε τον επιλεγμένο τύπο αρχείου;'
            }),
            itemLabel: selected.descr,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setFileTypesList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                const deleteSource = originalFileTypes[selected.id] ?? selected;
                await configuration.postFileTypes([buildFileTypePayloadItem({ ...deleteSource, isDeleted: true })]);
                await fileTypesDataQuery.refetch();
                setFileTypesChanges({});
                setOriginalFileTypes({});
                setIsFileTypesChanged(false);
            }
        });
    };

    const handleSaveFileTypes = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;
        try {
            fileTypesGridRef.current?.finishEditing();
            const invalidItem = fileTypesList.find((item) => !item.isDeleted && Object.keys(validateFileTypeItem(item)).length > 0);
            if (invalidItem) {
                showLookupError(t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' }));
                return;
            }

            const cleanList = fileTypesList.map(buildFileTypePayloadItem);

            await configuration.postFileTypes(cleanList);
            await fileTypesDataQuery.refetch();

            setFileTypesChanges({});
            setIsFileTypesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    const handleFileTypeModalSave = () => {
        const validationErrors = validateFileTypeItem(fileTypeModalItem);
        setFileTypesErrors(validationErrors); // Add this state if not already declared

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setFileTypesList((prev) => {
            const isEdit = fileTypeModalItem.id !== null && !fileTypeModalItem.isNew;
            const updated = { ...fileTypeModalItem, isNew: false, isDeleted: false };
            return isEdit
                ? prev.map((item) => (item.id === fileTypeModalItem.id ? updated : item))
                : [...prev, { ...updated, isNew: true }];
        });

        setIsFileTypesChanged(true);
        setIsFileTypeModalOpen(false);
        setFileTypesErrors({});
    };

    /*###############################################
  ############# LK Optional Answers ##############
  ###############################################*/

    const initializeOptionalAnswers = (flex) => {
        optionalAnswersGridRef.current = flex;
        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalOptionalAnswers(originalData);

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalOptionalAnswers[editedItem.id]?.[editedField];
            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedOptionalAnswerSnapshot) {
                    setOptionalAnswersBeforeEdit(JSON.parse(JSON.stringify(optionalAnswersList)));
                    setHasCapturedOptionalAnswerSnapshot(true);
                }

                setOptionalAnswerChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsOptionalAnswerChanged(true);
            }
        });
    };

    const validateOptionalAnswerItem = (item) => {
        const errors = {};

        if (!item.title || item.title.trim() === '') {
            errors.title = 'Title is required.';
        }

        if (item.title?.length > 200) {
            errors.title = 'Max 200 characters.';
        }

        if (item.position == null || isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        } else if (item.position < 0) {
            errors.position = 'Position must be a positive number.';
        }

        if (!item.questionId) {
            errors.questionId = 'Question is required.';
        }

        if (item.optionalAnswerCode1?.length > 50) {
            errors.optionalAnswerCode1 = 'Code 1 must be max 50 characters.';
        }

        if (item.optionalAnswerCode2?.length > 50) {
            errors.optionalAnswerCode2 = 'Code 2 must be max 50 characters.';
        }

        return errors;
    };

    // Add Optional Answer
    const handleAddOptionalAnswer = () => {
        setOptionalAnswersBeforeEdit(JSON.parse(JSON.stringify(optionalAnswersList))); // snapshot
        setHasCapturedOptionalAnswerSnapshot(true);

        setOptionalAnswerModalItem({
            id: crypto.randomUUID(),
            questionId: '',
            title: '',
            isCorrect: false,
            position: 0,
            statusId: 1,
            isActive: true,
            isDisabled: false,
            optionalAnswerCode1: '',
            optionalAnswerCode2: '',
            createdAt: new Date().toISOString(),
            isNew: true,
            isDeleted: false
        });
        setIsOptionalAnswerModalOpen(true);
    };

    const handleDeleteOptionalAnswer = () => {
        const selected = getSelectedGridItem(optionalAnswersGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteOptionalAnswerQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη απάντηση;'
            }),
            itemLabel: selected.title,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setOptionalAnswersList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                await configuration.postOptionalAnswers([{ ...selected, isDeleted: true, isNew: false }]);
                await optionalAnswerDataQuery.refetch();
                setOptionalAnswerChanges({});
                setIsOptionalAnswerChanged(false);
                setHasCapturedOptionalAnswerSnapshot(false);
            }
        });
    };

    const handleOptionalAnswerModalSave = () => {
        const validationErrors = validateOptionalAnswerItem(optionalAnswerModalItem);
        setOptionalAnswerErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const selectedQuestion = questionList.find((q) => q.id === optionalAnswerModalItem.questionId);

        const enrichedItem = {
            ...optionalAnswerModalItem,
            questionTitle: selectedQuestion?.title ?? `Q#${optionalAnswerModalItem.questionId}`,
            isNew: optionalAnswerModalItem.isNew ?? true,
            isDeleted: false
        };

        setOptionalAnswersList((prev) => {
            const isEdit = optionalAnswerModalItem.id && !optionalAnswerModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === optionalAnswerModalItem.id ? enrichedItem : item));
            } else {
                return [...prev, enrichedItem];
            }
        });

        setIsOptionalAnswerChanged(true);
        setIsOptionalAnswerModalOpen(false);
        setOptionalAnswerErrors({});
    };

    const handleSaveOptionalAnswers = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;
        try {
            const grid = optionalAnswersGridRef.current;
            if (grid?.collectionView) grid.finishEditing();
            const invalidItem = optionalAnswersList.find(
                (item) => !item.isDeleted && Object.keys(validateOptionalAnswerItem(item)).length > 0
            );
            if (invalidItem) {
                showLookupError(t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' }));
                return;
            }

            const cleanList = optionalAnswersList.map((item) => ({
                ...item,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postOptionalAnswers(cleanList);
            await optionalAnswerDataQuery.refetch(); // refresh

            setOptionalAnswerChanges({});
            setIsOptionalAnswerChanged(false);

            if (grid?.collectionView) {
                grid.collectionView.itemsAdded.length = 0;
                grid.collectionView.itemsRemoved.length = 0;
                grid.collectionView.itemsEdited.length = 0;
            }
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    /*###############################################
  ################ LK Question ####################
  ###############################################*/

    const initializeQuestions = (flex) => {
        questionsGridRef.current = flex;
        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalQuestions(originalData);

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalQuestions[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedQuestionSnapshot) {
                    setQuestionListBeforeEdit(JSON.parse(JSON.stringify(questionList)));
                    setHasCapturedQuestionSnapshot(true);
                }

                setQuestionChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsQuestionChanged(true);
            }
        });
    };

    const validateQuestionItem = (item) => {
        const errors = {};

        if (!item.code || item.code.trim() === '') {
            errors.code = 'Code is required.';
        } else if (item.code.length > 50) {
            errors.code = 'Code must be 50 characters or less.';
        }

        if (!item.title || item.title.trim() === '') {
            errors.title = 'Title is required.';
        } else if (item.title.length > 100) {
            errors.title = 'Title must be 100 characters or less.';
        }

        if (item.description && item.description.length > 500) {
            errors.description = 'Description must be 500 characters or less.';
        }

        if (!item.typeId || isNaN(item.typeId)) {
            errors.typeId = 'Question Type is required.';
        }

        if (item.limitLow != null && isNaN(item.limitLow)) {
            errors.limitLow = 'Limit Low must be a valid number.';
        }

        if (item.limitHigh != null && isNaN(item.limitHigh)) {
            errors.limitHigh = 'Limit High must be a valid number.';
        }

        return errors;
    };

    const handleAddQuestion = () => {
        setQuestionListBeforeEdit(JSON.parse(JSON.stringify(questionList)));
        setHasCapturedQuestionSnapshot(true);
        setQuestionModalItem({
            id: crypto.randomUUID(),
            code: '',
            title: '',
            description: '',
            typeId: null,
            acceptsMultipleAnswers: false,
            isInteger: false,
            limitLow: null,
            limitHigh: null,
            hasCorrectAnswers: false,
            createdAt: new Date().toISOString(),
            isNew: true,
            isDeleted: false
        });
        setIsQuestionModalOpen(true);
    };

    const handleDeleteQuestion = () => {
        const selected = getSelectedGridItem(questionsGridRef);
        if (!selected) return;

        openLookupDeleteDialog({
            message: t('DeleteQuestionQuestion', {
                defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη ερώτηση;'
            }),
            itemLabel: selected.title,
            onConfirm: async () => {
                if (selected.isNew || !selected.id) {
                    setQuestionList((prev) => prev.filter((item) => item !== selected));
                    return;
                }

                await configuration.postQuestion([{ ...selected, isDeleted: true, isNew: false }]);
                const { data: updatedData } = await questionDataQuery.refetch();
                const freshData = updatedData.map((item) => ({
                    ...item,
                    isNew: false,
                    isDeleted: false
                }));
                setQuestionList(freshData);
                setOriginalQuestions(Object.fromEntries(freshData.map((item) => [item.id, { ...item }])));
                setLastCommittedQuestions(freshData);
                setQuestionChanges({});
                setIsQuestionChanged(false);
                setHasCapturedQuestionSnapshot(false);
            }
        });
    };

    const handleSaveQuestions = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;
        try {
            questionsGridRef.current?.finishEditing();
            const invalidItem = questionList.find((item) => !item.isDeleted && Object.keys(validateQuestionItem(item)).length > 0);
            if (invalidItem) {
                showLookupError(t('InvalidLookupRow', { defaultValue: 'Παρακαλώ διορθώστε τα λάθη στον πίνακα πριν την αποθήκευση.' }));
                return;
            }

            const cleanList = questionList.map((item) => ({
                ...item,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postQuestion(cleanList);

            const { data: updatedData } = await questionDataQuery.refetch(); // use returned data
            const freshData = updatedData.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));

            setQuestionList(freshData);
            setOriginalQuestions(Object.fromEntries(freshData.map((item) => [item.id, { ...item }])));
            setLastCommittedQuestions(freshData);

            setQuestionChanges({});
            setIsQuestionChanged(false);
            setHasCapturedQuestionSnapshot(false);
        } catch (err) {
            console.error('Save failed:', err);
            showLookupError(getChecklistErrorMessage(err, t('SaveFailed', { defaultValue: 'Η αποθήκευση απέτυχε.' })));
        }
    };

    const handleQuestionModalSave = () => {
        const validationErrors = validateQuestionItem(questionModalItem);
        setQuestionErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        setQuestionList((prev) => {
            const isEdit = questionModalItem.id && !questionModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === questionModalItem.id ? { ...questionModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...questionModalItem, isNew: true }];
            }
        });

        setIsQuestionModalOpen(false);
        setIsQuestionChanged(true);
        setQuestionErrors({});
    };

    return {
        loading: <p> loading </p>,
        success: (
            <>
                <div style={{ textAlign: 'center', fontSize: 30, fontWeight: 'bold', margin: '20px' }}>
                    <h1>Checklist</h1>
                </div>

                <SimpleAccordion
                    title={<Typography variant="h6">LK Season</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Season</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddSeason}
                                        startIcon={<AddIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none',
                                            boxShadow: 2
                                        }}
                                    >
                                        {t('Add', { defaultValue: 'Προσθήκη' })}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={handleDeleteSeason}
                                        startIcon={<DeleteIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none'
                                        }}
                                    >
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                    {isSeasonChanged && (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleSaveSeason}
                                            startIcon={<SaveIcon />}
                                            sx={{
                                                minWidth: 130,
                                                height: 36,
                                                fontSize: 14,
                                                textTransform: 'none',
                                                boxShadow: 2
                                            }}
                                        >
                                            {t('Save', { defaultValue: 'Αποθήκευση' })}
                                        </Button>
                                    )}
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    // Ensure any in-progress edit is committed before reset
                    seasonGridRef.current?.finishEditing();

                    const restored = JSON.parse(JSON.stringify(seasonBeforeSaveRef.current));
                    setSeasonList(restored);
                    setIsSeasonChanged(false);
                    seasonGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isSeasonChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeSeason(flex)}
                                className="explorer-grid"
                                itemsSource={seasonList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Περιγραφή" binding="description" width="*" />
                                <FlexGridColumn header="Έναρξη" binding="dateFrom" width="*" />
                                <FlexGridColumn header="Λήξη" binding="dateTo" width="*" />
                                <FlexGridColumn header="Ενεργή" binding="isActive" width="*" />
                                <FlexGridColumn header="θέση" binding="position" width="*" align="left" />
                            </FlexGrid>
                            <Dialog open={isSeasonModalOpen} onClose={() => setIsSeasonModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Edit Season</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Description"
                                        value={seasonModalItem?.description || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, description: e.target.value })}
                                        error={!!seasonErrors.description}
                                        helperText={seasonErrors.description}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={seasonModalItem?.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, abbr: e.target.value })}
                                        error={!!seasonErrors.abbr}
                                        helperText={seasonErrors.abbr}
                                    />
                                    <TextField
                                        label="Date From"
                                        type="date"
                                        value={seasonModalItem?.dateFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, dateFrom: e.target.value })}
                                        error={!!seasonErrors.dateFrom}
                                        helperText={seasonErrors.dateFrom}
                                    />
                                    <TextField
                                        label="Date To"
                                        type="date"
                                        value={seasonModalItem?.dateTo || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, dateTo: e.target.value })}
                                        error={!!seasonErrors.dateTo}
                                        helperText={seasonErrors.dateTo}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={seasonModalItem?.position || 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, position: Number(e.target.value) })}
                                        error={!!seasonErrors.position}
                                        helperText={seasonErrors.position}
                                    />
                                    <TextField
                                        label="DataKey"
                                        value={seasonModalItem?.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, dataKey: e.target.value })}
                                        error={!!seasonErrors.dataKey}
                                        helperText={seasonErrors.dataKey}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={seasonModalItem?.isActive ?? true}
                                                onChange={(e) => setSeasonModalItem({ ...seasonModalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsSeasonModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleSeasonModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isSeasonDeleteOpen}
                                onClose={() => {
                                    setSeasonDeleteItem(null);
                                    setIsSeasonDeleteOpen(false);
                                }}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogTitle>{t('Delete', { defaultValue: 'Διαγραφή' })}</DialogTitle>
                                <DialogContent>
                                    <Typography>
                                        {t('DeleteSeasonQuestion', {
                                            defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη αγωνιστική περίοδο;'
                                        })}
                                    </Typography>
                                    {seasonDeleteItem && (
                                        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                                            {seasonDeleteItem.description}
                                        </Typography>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={() => {
                                            setSeasonDeleteItem(null);
                                            setIsSeasonDeleteOpen(false);
                                        }}
                                    >
                                        {t('Cancel', { defaultValue: 'Ακύρωση' })}
                                    </Button>
                                    <Button variant="contained" color="error" onClick={confirmDeleteSeason}>
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={!!seasonValidationMessage}
                                onClose={() => setSeasonValidationMessage('')}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogContent
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 3,
                                        py: 4
                                    }}
                                >
                                    <HighlightOffIcon sx={{ color: 'error.main', fontSize: 64, flex: '0 0 auto' }} />
                                    <Typography sx={{ whiteSpace: 'pre-line' }}>{seasonValidationMessage}</Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" onClick={() => setSeasonValidationMessage('')}>
                                        OK
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Application Type</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Application Type</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddApplicationType}
                                        startIcon={<AddIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none',
                                            boxShadow: 2
                                        }}
                                    >
                                        {t('Add', { defaultValue: 'Προσθήκη' })}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={handleDeleteApplicationType}
                                        startIcon={<DeleteIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none'
                                        }}
                                    >
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                    {isApplicationTypeChanged && (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleSaveApplicationType}
                                            startIcon={<SaveIcon />}
                                            sx={{
                                                minWidth: 130,
                                                height: 36,
                                                fontSize: 14,
                                                textTransform: 'none',
                                                boxShadow: 2
                                            }}
                                        >
                                            {t('Save', { defaultValue: 'Αποθήκευση' })}
                                        </Button>
                                    )}
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setApplicationTypeList(applicationTypeListBeforeEdit);
                    setIsApplicationTypeChanged(false);
                    applicationTypeGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isApplicationTypeChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeApplicationType(flex)}
                                className="explorer-grid"
                                itemsSource={applicationTypeList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Id" binding="id" width={80} dataType="Number" isReadOnly={true} />
                                <FlexGridColumn header="Description" binding="description" width={260} dataType="String" align="left" />
                                <FlexGridColumn header="Abbr" binding="abbr" width={140} dataType="String" align="left" />
                                <FlexGridColumn header="Hint" binding="hint" width={220} dataType="String" align="left" />
                                <FlexGridColumn header="Position" binding="position" width={100} dataType="Number" align="left" />
                                <FlexGridColumn header="ConcernAthlete" binding="concernAthlete" width={130} dataType="Boolean" align="center" />
                                <FlexGridColumn header="ConcernOfficial" binding="concernOfficial" width={140} dataType="Boolean" align="center" />
                                <FlexGridColumn header="ConcernOrganization" binding="concernOrganization" width={170} dataType="Boolean" align="center" />
                                <FlexGridColumn header="IsNewAction" binding="isNewAction" width={120} dataType="Boolean" align="center" />
                                <FlexGridColumn header="IsEditAction" binding="isEditAction" width={120} dataType="Boolean" align="center" />
                                <FlexGridColumn header="CopyFiles" binding="copyFiles" width={110} dataType="Boolean" align="center" />
                                <FlexGridColumn header="Active" binding="isActive" width={100} dataType="Boolean" align="center" />
                                <FlexGridColumn header="ReqKeyB4Submit" binding="reqKeyB4Submit" width={140} dataType="Boolean" align="center" />
                                <FlexGridColumn header="CopyFiles DataKey" binding="copyFiles_DataKey" width={180} dataType="String" align="left" />
                                <FlexGridColumn header="DataKey" binding="dataKey" width={180} dataType="String" align="left" />
                                <FlexGridColumn header="Render Options" binding="renderOptions" width={240} dataType="String" align="left" />
                                <FlexGridColumn header="Comments" binding="comments" width={240} dataType="String" align="left" />
                            </FlexGrid>
                            <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Edit Application Type</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Id"
                                        type="number"
                                        value={modalItem?.id || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, id: Number(e.target.value) })}
                                        error={!!applicationTypeErrors.id}
                                        helperText={applicationTypeErrors.id}
                                    />

                                    <TextField
                                        label="Description"
                                        value={modalItem?.description || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, description: e.target.value })}
                                        error={!!applicationTypeErrors.description}
                                        helperText={applicationTypeErrors.description}
                                    />

                                    <TextField
                                        label="Abbr"
                                        value={modalItem?.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, abbr: e.target.value })}
                                        error={!!applicationTypeErrors.abbr}
                                        helperText={applicationTypeErrors.abbr}
                                    />

                                    <TextField
                                        label="Hint"
                                        value={modalItem?.hint || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, hint: e.target.value })}
                                    />

                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={modalItem?.position || 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, position: Number(e.target.value) })}
                                        error={!!applicationTypeErrors.position}
                                        helperText={applicationTypeErrors.position}
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.concernAthlete || false}
                                                onChange={(e) => setModalItem({ ...modalItem, concernAthlete: e.target.checked })}
                                            />
                                        }
                                        label="Concern Athlete"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.concernOfficial || false}
                                                onChange={(e) => setModalItem({ ...modalItem, concernOfficial: e.target.checked })}
                                            />
                                        }
                                        label="Concern Official"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.concernOrganization || false}
                                                onChange={(e) => setModalItem({ ...modalItem, concernOrganization: e.target.checked })}
                                            />
                                        }
                                        label="Concern Organization"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.isNewAction || false}
                                                onChange={(e) => setModalItem({ ...modalItem, isNewAction: e.target.checked })}
                                            />
                                        }
                                        label="Is New Action"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.isEditAction || false}
                                                onChange={(e) => setModalItem({ ...modalItem, isEditAction: e.target.checked })}
                                            />
                                        }
                                        label="Is Edit Action"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.copyFiles || false}
                                                onChange={(e) => setModalItem({ ...modalItem, copyFiles: e.target.checked })}
                                            />
                                        }
                                        label="Copy Files"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.isActive || false}
                                                onChange={(e) => setModalItem({ ...modalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.reqKeyB4Submit || false}
                                                onChange={(e) => setModalItem({ ...modalItem, reqKeyB4Submit: e.target.checked })}
                                            />
                                        }
                                        label="Require Key Before Submit"
                                    />

                                    <TextField
                                        label="CopyFiles DataKey"
                                        value={modalItem?.copyFiles_DataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, copyFiles_DataKey: e.target.value })}
                                        error={!!applicationTypeErrors.copyFiles_DataKey}
                                        helperText={applicationTypeErrors.copyFiles_DataKey}
                                    />

                                    <TextField
                                        label="DataKey"
                                        value={modalItem?.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, dataKey: e.target.value })}
                                        error={!!applicationTypeErrors.dataKey}
                                        helperText={applicationTypeErrors.dataKey}
                                    />

                                    <TextField
                                        label="Render Options"
                                        value={modalItem?.renderOptions || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, renderOptions: e.target.value })}
                                        error={!!applicationTypeErrors.renderOptions}
                                        helperText={applicationTypeErrors.renderOptions}
                                    />

                                    <TextField
                                        label="Comments"
                                        value={modalItem?.comments || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        rows={3}
                                        onChange={(e) => setModalItem({ ...modalItem, comments: e.target.value })}
                                        error={!!applicationTypeErrors.comments}
                                        helperText={applicationTypeErrors.comments}
                                    />
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleApplicationTypeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isApplicationTypeDeleteOpen}
                                onClose={() => {
                                    setApplicationTypeDeleteItem(null);
                                    setIsApplicationTypeDeleteOpen(false);
                                }}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogTitle>{t('Delete', { defaultValue: 'Διαγραφή' })}</DialogTitle>
                                <DialogContent>
                                    <Typography>
                                        {t('DeleteApplicationTypeQuestion', {
                                            defaultValue: 'Θέλετε σίγουρα να διαγράψετε τον επιλεγμένο τύπο αίτησης;'
                                        })}
                                    </Typography>
                                    {applicationTypeDeleteItem && (
                                        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                                            {applicationTypeDeleteItem.description}
                                        </Typography>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={() => {
                                            setApplicationTypeDeleteItem(null);
                                            setIsApplicationTypeDeleteOpen(false);
                                        }}
                                    >
                                        {t('Cancel', { defaultValue: 'Ακύρωση' })}
                                    </Button>
                                    <Button variant="contained" color="error" onClick={confirmDeleteApplicationType}>
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={!!applicationTypeValidationMessage}
                                onClose={() => setApplicationTypeValidationMessage('')}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogContent
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 3,
                                        py: 4
                                    }}
                                >
                                    <HighlightOffIcon sx={{ color: 'error.main', fontSize: 64, flex: '0 0 auto' }} />
                                    <Typography sx={{ whiteSpace: 'pre-line' }}>{applicationTypeValidationMessage}</Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" onClick={() => setApplicationTypeValidationMessage('')}>
                                        OK
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Events</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Events</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddEvent}
                                        startIcon={<AddIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none',
                                            boxShadow: 2
                                        }}
                                    >
                                        {t('Add', { defaultValue: 'Προσθήκη' })}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={handleDeleteEvent}
                                        startIcon={<DeleteIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none'
                                        }}
                                    >
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                    {isEventChanged && (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleSaveEvent}
                                            startIcon={<SaveIcon />}
                                            sx={{
                                                minWidth: 130,
                                                height: 36,
                                                fontSize: 14,
                                                textTransform: 'none',
                                                boxShadow: 2
                                            }}
                                        >
                                            {t('Save', { defaultValue: 'Αποθήκευση' })}
                                        </Button>
                                    )}
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeEvents(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={eventList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Code" binding="code" width={90} dataType="Number" align="left" />
                                <FlexGridColumn
                                    header="DisciplineId"
                                    binding="disciplineId"
                                    width={220}
                                    dataType="Number"
                                    dataMap={new wjGrid.DataMap(eventDisciplines, 'id', 'name')}
                                />
                                <FlexGridColumn header="Name" binding="name" width={240} dataType="String" align="left" />
                                <FlexGridColumn header="Abbr" binding="abbr" width={130} dataType="String" align="left" />
                                <FlexGridColumn header="NameEn" binding="nameEn" width={220} dataType="String" align="left" />
                                <FlexGridColumn header="AbbrEn" binding="abbrEn" width={130} dataType="String" align="left" />
                                <FlexGridColumn header="TotalAthletes" binding="totalAthletes" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="TotalObjects" binding="totalObjects" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="IsTeam" binding="isTeam" width={100} dataType="Boolean" align="center" />
                                <FlexGridColumn header="IsActive" binding="isActive" width={100} dataType="Boolean" align="center" />
                                <FlexGridColumn
                                    header="ResultsFieldsMappingJson"
                                    binding="resultsFieldsMappingJson"
                                    width={260}
                                    dataType="String"
                                    align="left"
                                />
                                <FlexGridColumn
                                    header="isCustomDivision"
                                    binding="isCustomDivision"
                                    width={140}
                                    dataType="Boolean"
                                    align="center"
                                />
                            </FlexGrid>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Discipline</Typography>}
                    content={
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK Discipline</h2>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddDiscipline}
                                        startIcon={<AddIcon />}
                                        sx={{
                                            backgroundColor: '#2196f3',
                                            color: '#fff',
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none',
                                            boxShadow: 2
                                        }}
                                    >
                                        {t('Add', { defaultValue: 'Προσθήκη' })}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={handleDeleteDiscipline}
                                        startIcon={<DeleteIcon />}
                                        sx={{
                                            minWidth: 120,
                                            height: 36,
                                            fontSize: 14,
                                            textTransform: 'none'
                                        }}
                                    >
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                    {isDisciplineChanged && (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleSaveDiscipline}
                                            startIcon={<SaveIcon />}
                                            sx={{
                                                minWidth: 130,
                                                height: 36,
                                                fontSize: 14,
                                                textTransform: 'none',
                                                boxShadow: 2
                                            }}
                                        >
                                            {t('Save', { defaultValue: 'Αποθήκευση' })}
                                        </Button>
                                    )}
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeDiscipline(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={disciplineList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="ID" binding="id" width={90} dataType="Number" isReadOnly={true} align="left" />
                                <FlexGridColumn
                                    header="Parent"
                                    binding="parentId"
                                    width={220}
                                    dataType="Number"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(disciplineParents) ? disciplineParents : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="Description" binding="name" width={260} dataType="String" align="left" />
                                <FlexGridColumn header="Abbr" binding="abbr" width={130} dataType="String" align="left" />
                                <FlexGridColumn header="Position" binding="position" width={100} dataType="Number" align="left" />
                                <FlexGridColumn header="DataKey" binding="dataKey" width={180} dataType="String" align="left" />
                                <FlexGridColumn header="IsActive" binding="isActive" width={100} dataType="Boolean" align="center" />
                                <FlexGridColumn header="Comments" binding="comments" width={260} dataType="String" align="left" />
                            </FlexGrid>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK AgeCategories</Typography>}
                    content={
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK AgeCategories</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddAgeCategory,
                                    onDelete: handleDeleteAgeCategory,
                                    onSave: handleSaveAgeCategory,
                                    isChanged: isAgeCategoryChanged
                                })}
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeAgeCategory(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={ageCategoryList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Code" binding="code" width="*" />
                                <FlexGridColumn header="Όνομα" binding="name" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn
                                    header="Gender"
                                    binding="gender"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            [
                                                { id: 'Θ', name: 'Θύλη' },
                                                { id: 'Α', name: 'Άρρεν' },
                                                { id: 'Χ', name: 'Μικτό' }
                                            ],
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="AgeFrom" binding="ageFrom" width="*" />
                                <FlexGridColumn header="AgeTo" binding="ageTo" width="*" />
                                <FlexGridColumn header="rAgeFrom" binding="rAgeFrom" width="*" />
                                <FlexGridColumn header="rAgeTo" binding="rAgeTo" width="*" />
                                <FlexGridColumn header="Θέση" binding="position" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                                <FlexGridColumn header="Custom" binding="isCustom" width="*" />
                            </FlexGrid>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Divisions</Typography>}
                    content={
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK Divisions</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddDivision,
                                    onDelete: handleDeleteDivision,
                                    onSave: handleSaveDivision,
                                    isChanged: isDivisionChanged
                                })}
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeDivision(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={divisionList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn
                                    header="DisciplineId"
                                    binding="disciplineId"
                                    width={220}
                                    dataType="Number"
                                    align="left"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(disciplineList) ? disciplineList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="EventId"
                                    binding="eventId"
                                    width={220}
                                    dataType="Number"
                                    align="left"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(eventList) ? eventList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="CompetitionTypeId"
                                    binding="competitionTypeId"
                                    width={220}
                                    dataType="Number"
                                    align="left"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(competitionTypeList) ? competitionTypeList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="AgeCategoryId"
                                    binding="ageCategoryId"
                                    width={220}
                                    dataType="Number"
                                    align="left"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(ageCategoryList) ? ageCategoryList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="Name" binding="name" width={240} dataType="String" align="left" />
                                <FlexGridColumn header="Abbr" binding="abbr" width={140} dataType="String" align="left" />
                                <FlexGridColumn header="Position" binding="position" width={110} dataType="Number" align="left" />
                                <FlexGridColumn header="Value1From" binding="value1From" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="Value1To" binding="value1To" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="Value2From" binding="value2From" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="Value2To" binding="value2To" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="Value3From" binding="value3From" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="Value3To" binding="value3To" width={120} dataType="Number" align="left" />
                                <FlexGridColumn header="isCustom" binding="isCustom" width={100} dataType="Boolean" align="center" />
                                <FlexGridColumn header="isNull" binding="isNull" width={100} dataType="Boolean" align="center" />
                            </FlexGrid>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK CompetitionTypes</Typography>}
                    content={
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK CompetitionTypes</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddCompetitionType,
                                    onDelete: handleDeleteCompetitionType,
                                    onSave: handleSaveCompetitionType,
                                    isChanged: isCompetitionTypeChanged
                                })}
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeCompetitionTypes(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={competitionTypeList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Όνομα" binding="name" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Θέση" binding="position" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                                <FlexGridColumn header="Σχόλια" binding="comments" width="*" />
                            </FlexGrid>
                        </>
                    }
                />

                <>
                            <Dialog open={isEventModalOpen} onClose={() => setIsEventModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Add/Edit Event</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Code"
                                        type="number"
                                        value={eventModalItem.code ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, code: Number(e.target.value) })}
                                        error={!!eventErrors.code}
                                        helperText={eventErrors.code}
                                    />
                                    <FormControl fullWidth margin="normal" error={!!eventErrors.disciplineId}>
                                        <InputLabel id="discipline-label">DisciplineId</InputLabel>
                                        <Select
                                            labelId="discipline-label"
                                            id="discipline"
                                            value={eventModalItem.disciplineId || ''}
                                            label="DisciplineId"
                                            onChange={(e) =>
                                                setEventModalItem({
                                                    ...eventModalItem,
                                                    disciplineId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {eventDisciplines.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {eventErrors.disciplineId && (
                                            <Typography variant="caption" color="error">
                                                {eventErrors.disciplineId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Name"
                                        value={eventModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, name: e.target.value })}
                                        error={!!eventErrors.name}
                                        helperText={eventErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={eventModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, abbr: e.target.value })}
                                        error={!!eventErrors.abbr}
                                        helperText={eventErrors.abbr}
                                    />
                                    <TextField
                                        label="NameEn"
                                        value={eventModalItem.nameEn || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, nameEn: e.target.value })}
                                        error={!!eventErrors.nameEn}
                                        helperText={eventErrors.nameEn}
                                    />
                                    <TextField
                                        label="AbbrEn"
                                        value={eventModalItem.abbrEn || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, abbrEn: e.target.value })}
                                        error={!!eventErrors.abbrEn}
                                        helperText={eventErrors.abbrEn}
                                    />
                                    <TextField
                                        label="TotalAthletes"
                                        type="number"
                                        value={eventModalItem.totalAthletes ?? 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, totalAthletes: Number(e.target.value) })}
                                        error={!!eventErrors.totalAthletes}
                                        helperText={eventErrors.totalAthletes}
                                    />
                                    <TextField
                                        label="TotalObjects"
                                        type="number"
                                        value={eventModalItem.totalObjects ?? 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, totalObjects: Number(e.target.value) })}
                                        error={!!eventErrors.totalObjects}
                                        helperText={eventErrors.totalObjects}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={eventModalItem.isTeam ?? false}
                                                onChange={(e) => setEventModalItem({ ...eventModalItem, isTeam: e.target.checked })}
                                            />
                                        }
                                        label="IsTeam"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={eventModalItem.isActive ?? true}
                                                onChange={(e) => setEventModalItem({ ...eventModalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="IsActive"
                                    />
                                    <TextField
                                        label="ResultsFieldsMappingJson"
                                        value={eventModalItem.resultsFieldsMappingJson || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        minRows={3}
                                        onChange={(e) =>
                                            setEventModalItem({ ...eventModalItem, resultsFieldsMappingJson: e.target.value })
                                        }
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={eventModalItem.isCustomDivision ?? false}
                                                onChange={(e) =>
                                                    setEventModalItem({ ...eventModalItem, isCustomDivision: e.target.checked })
                                                }
                                            />
                                        }
                                        label="isCustomDivision"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsEventModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleEventModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isEventDeleteOpen}
                                onClose={() => {
                                    setEventDeleteItem(null);
                                    setIsEventDeleteOpen(false);
                                }}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogTitle>{t('Delete', { defaultValue: 'Διαγραφή' })}</DialogTitle>
                                <DialogContent>
                                    <Typography>
                                        {t('DeleteEventQuestion', {
                                            defaultValue: 'Θέλετε σίγουρα να διαγράψετε το επιλεγμένο αγώνισμα;'
                                        })}
                                    </Typography>
                                    {eventDeleteItem && (
                                        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                                            {eventDeleteItem.name}
                                        </Typography>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={() => {
                                            setEventDeleteItem(null);
                                            setIsEventDeleteOpen(false);
                                        }}
                                    >
                                        {t('Cancel', { defaultValue: 'Ακύρωση' })}
                                    </Button>
                                    <Button variant="contained" color="error" onClick={confirmDeleteEvent}>
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={!!eventValidationMessage}
                                onClose={() => setEventValidationMessage('')}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogContent
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 3,
                                        py: 4
                                    }}
                                >
                                    <HighlightOffIcon sx={{ color: 'error.main', fontSize: 64, flex: '0 0 auto' }} />
                                    <Typography sx={{ whiteSpace: 'pre-line' }}>{eventValidationMessage}</Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" onClick={() => setEventValidationMessage('')}>
                                        OK
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={isDisciplineModalOpen} onClose={() => setIsDisciplineModalOpen(false)} maxWidth="sm" fullWidth>
                                <DialogTitle>Add/Edit Discipline</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Id"
                                        type="number"
                                        value={disciplineModalItem.id ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, id: Number(e.target.value) })}
                                        error={!!disciplineErrors.id}
                                        helperText={disciplineErrors.id}
                                    />
                                    <FormControl fullWidth margin="normal" error={!!disciplineErrors.parentId}>
                                        <InputLabel id="parent-label">Parent</InputLabel>
                                        <Select
                                            labelId="parent-label"
                                            id="parent"
                                            value={disciplineModalItem.parentId ?? 999}
                                            label="Parent"
                                            onChange={(e) =>
                                                setDisciplineModalItem({
                                                    ...disciplineModalItem,
                                                    parentId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {Array.isArray(disciplineParents) && disciplineParents.length > 0 ? (
                                                disciplineParents.map((d) => (
                                                    <MenuItem key={d.id} value={d.id}>
                                                        {d.name}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No children</MenuItem>
                                            )}
                                        </Select>
                                        {disciplineErrors.parentId && (
                                            <Typography variant="caption" color="error">
                                                {disciplineErrors.parentId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Description"
                                        value={disciplineModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, name: e.target.value })}
                                        error={!!disciplineErrors.name}
                                        helperText={disciplineErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={disciplineModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, abbr: e.target.value })}
                                        error={!!disciplineErrors.abbr}
                                        helperText={disciplineErrors.abbr}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={disciplineModalItem.position ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDisciplineModalItem({ ...disciplineModalItem, position: Number(e.target.value) })
                                        }
                                        error={!!disciplineErrors.position}
                                        helperText={disciplineErrors.position}
                                    />
                                    <TextField
                                        label="DataKey"
                                        value={disciplineModalItem.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, dataKey: e.target.value })}
                                        error={!!disciplineErrors.dataKey}
                                        helperText={disciplineErrors.dataKey}
                                    />
                                    <TextField
                                        label="Comments"
                                        value={disciplineModalItem.comments || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, comments: e.target.value })}
                                        error={!!disciplineErrors.comments}
                                        helperText={disciplineErrors.comments}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={disciplineModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setDisciplineModalItem({ ...disciplineModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsDisciplineModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleDisciplineModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isDisciplineDeleteOpen}
                                onClose={() => {
                                    setDisciplineDeleteItem(null);
                                    setIsDisciplineDeleteOpen(false);
                                }}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogTitle>{t('Delete', { defaultValue: 'Διαγραφή' })}</DialogTitle>
                                <DialogContent>
                                    <Typography>
                                        {t('DeleteDisciplineQuestion', {
                                            defaultValue: 'Θέλετε σίγουρα να διαγράψετε την επιλεγμένη κατηγορία αγωνίσματος;'
                                        })}
                                    </Typography>
                                    {disciplineDeleteItem && (
                                        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                                            {disciplineDeleteItem.name}
                                        </Typography>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={() => {
                                            setDisciplineDeleteItem(null);
                                            setIsDisciplineDeleteOpen(false);
                                        }}
                                    >
                                        {t('Cancel', { defaultValue: 'Ακύρωση' })}
                                    </Button>
                                    <Button variant="contained" color="error" onClick={confirmDeleteDiscipline}>
                                        {t('Delete', { defaultValue: 'Διαγραφή' })}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={!!disciplineValidationMessage}
                                onClose={() => setDisciplineValidationMessage('')}
                                maxWidth="xs"
                                fullWidth
                            >
                                <DialogContent
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 3,
                                        py: 4
                                    }}
                                >
                                    <HighlightOffIcon sx={{ color: 'error.main', fontSize: 64, flex: '0 0 auto' }} />
                                    <Typography sx={{ whiteSpace: 'pre-line' }}>{disciplineValidationMessage}</Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" onClick={() => setDisciplineValidationMessage('')}>
                                        OK
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={isAgeCategoryModalOpen} onClose={() => setIsAgeCategoryModalOpen(false)} maxWidth="sm" fullWidth>
                                <DialogTitle>Add/Edit Age Category</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Name"
                                        value={AgeCategoryModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setAgeCategoryModalItem({ ...AgeCategoryModalItem, name: e.target.value })}
                                        error={!!ageCategoryErrors.name}
                                        helperText={ageCategoryErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={AgeCategoryModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setAgeCategoryModalItem({ ...AgeCategoryModalItem, abbr: e.target.value })}
                                        error={!!ageCategoryErrors.abbr}
                                        helperText={ageCategoryErrors.abbr}
                                    />
                                    <TextField
                                        label="Code"
                                        type="number"
                                        value={AgeCategoryModalItem.code ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({
                                                ...AgeCategoryModalItem,
                                                code: e.target.value === '' ? null : Number(e.target.value)
                                            })
                                        }
                                        error={!!ageCategoryErrors.code}
                                        helperText={ageCategoryErrors.code}
                                    />
                                    <FormControl fullWidth margin="normal" error={!!ageCategoryErrors.gender}>
                                        <InputLabel id="gender-label">Gender</InputLabel>
                                        <Select
                                            labelId="gender-label"
                                            id="gender"
                                            value={AgeCategoryModalItem.gender || ''}
                                            label="Gender"
                                            onChange={(e) =>
                                                setAgeCategoryModalItem({
                                                    ...AgeCategoryModalItem,
                                                    gender: e.target.value
                                                })
                                            }
                                        >
                                            {[
                                                { id: 'Θ', name: 'Θύλη' },
                                                { id: 'Α', name: 'Άρρεν' },
                                                { id: 'Χ', name: 'Μικτό' }
                                            ].map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {ageCategoryErrors.gender && (
                                            <Typography variant="caption" color="error">
                                                {ageCategoryErrors.gender}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="AgeFrom"
                                        type="number"
                                        value={AgeCategoryModalItem.ageFrom ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({
                                                ...AgeCategoryModalItem,
                                                ageFrom: e.target.value === '' ? null : Number(e.target.value)
                                            })
                                        }
                                        error={!!ageCategoryErrors.ageFrom}
                                        helperText={ageCategoryErrors.ageFrom}
                                    />
                                    <TextField
                                        label="AgeTo"
                                        type="number"
                                        value={AgeCategoryModalItem.ageTo ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({
                                                ...AgeCategoryModalItem,
                                                ageTo: e.target.value === '' ? null : Number(e.target.value)
                                            })
                                        }
                                        error={!!ageCategoryErrors.ageTo}
                                        helperText={ageCategoryErrors.ageTo}
                                    />
                                    <TextField
                                        label="RageFrom"
                                        type="number"
                                        value={AgeCategoryModalItem.rAgeFrom ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({
                                                ...AgeCategoryModalItem,
                                                rAgeFrom: e.target.value === '' ? null : Number(e.target.value)
                                            })
                                        }
                                        error={!!ageCategoryErrors.rAgeFrom}
                                        helperText={ageCategoryErrors.rAgeFrom}
                                    />
                                    <TextField
                                        label="RageTo"
                                        type="number"
                                        value={AgeCategoryModalItem.rAgeTo ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({
                                                ...AgeCategoryModalItem,
                                                rAgeTo: e.target.value === '' ? null : Number(e.target.value)
                                            })
                                        }
                                        error={!!ageCategoryErrors.rAgeTo}
                                        helperText={ageCategoryErrors.rAgeTo}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={AgeCategoryModalItem.position ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({
                                                ...AgeCategoryModalItem,
                                                position: e.target.value === '' ? null : Number(e.target.value)
                                            })
                                        }
                                        error={!!ageCategoryErrors.position}
                                        helperText={ageCategoryErrors.position}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={AgeCategoryModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setAgeCategoryModalItem({ ...AgeCategoryModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={AgeCategoryModalItem.isCustom ?? false}
                                                onChange={(e) =>
                                                    setAgeCategoryModalItem({ ...AgeCategoryModalItem, isCustom: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Custom"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsAgeCategoryModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleAgeCategoryModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={isDivisionModalOpen} onClose={() => setIsDivisionModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Add/Edit Divisions</DialogTitle>
                                <DialogContent dividers>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.disciplineId}>
                                        <InputLabel id="disciplineId-label">DisciplineId</InputLabel>
                                        <Select
                                            labelId="disciplineId-label"
                                            id="disciplineId"
                                            value={DivisionModalItem.disciplineId ?? ''}
                                            label="DisciplineId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    disciplineId: parseNullableNumber(e.target.value)
                                                })
                                            }
                                        >
                                            {disciplineList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.disciplineId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.disciplineId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.eventId}>
                                        <InputLabel id="eventId-label">EventId</InputLabel>
                                        <Select
                                            labelId="eventId-label"
                                            id="eventId"
                                            value={DivisionModalItem.eventId ?? ''}
                                            label="EventId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    eventId: parseNullableNumber(e.target.value)
                                                })
                                            }
                                        >
                                            <MenuItem value="">-</MenuItem>
                                            {eventList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.eventId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.eventId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.competitionTypeId}>
                                        <InputLabel id="competitionTypeId-label">CompetitionTypeId</InputLabel>
                                        <Select
                                            labelId="competitionTypeId-label"
                                            id="competitionTypeId"
                                            value={DivisionModalItem.competitionTypeId ?? ''}
                                            label="CompetitionTypeId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    competitionTypeId: parseNullableNumber(e.target.value)
                                                })
                                            }
                                        >
                                            <MenuItem value="">-</MenuItem>
                                            {competitionTypeList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.competitionTypeId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.competitionTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.ageCategoryId}>
                                        <InputLabel id="ageCategoryId-label">AgeCategoryId</InputLabel>
                                        <Select
                                            labelId="ageCategoryId-label"
                                            id="ageCategoryId"
                                            value={DivisionModalItem.ageCategoryId ?? ''}
                                            label="AgeCategoryId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    ageCategoryId: parseNullableNumber(e.target.value)
                                                })
                                            }
                                        >
                                            <MenuItem value="">-</MenuItem>
                                            {ageCategoryList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.ageCategoryId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.ageCategoryId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Name"
                                        value={DivisionModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDivisionModalItem({ ...DivisionModalItem, name: e.target.value })}
                                        error={!!divisionErrors.name}
                                        helperText={divisionErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={DivisionModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDivisionModalItem({ ...DivisionModalItem, abbr: e.target.value })}
                                        error={!!divisionErrors.abbr}
                                        helperText={divisionErrors.abbr}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={DivisionModalItem.position ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                position: parseNullableNumber(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.position}
                                        helperText={divisionErrors.position}
                                    />
                                    <TextField
                                        label="Value1From"
                                        type="number"
                                        value={DivisionModalItem.value1From ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                value1From: parseNullableNumber(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.value1From}
                                        helperText={divisionErrors.value1From}
                                    />
                                    <TextField
                                        label="Value1To"
                                        type="number"
                                        value={DivisionModalItem.value1To ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                value1To: parseNullableNumber(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.value1To}
                                        helperText={divisionErrors.value1To}
                                    />
                                    <TextField
                                        label="Value2From"
                                        type="number"
                                        value={DivisionModalItem.value2From ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                value2From: parseNullableNumber(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.value2From}
                                        helperText={divisionErrors.value2From}
                                    />
                                    <TextField
                                        label="Value2To"
                                        type="number"
                                        value={DivisionModalItem.value2To ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                value2To: parseNullableNumber(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.value2To}
                                        helperText={divisionErrors.value2To}
                                    />
                                    <TextField
                                        label="Value3From"
                                        type="number"
                                        value={DivisionModalItem.value3From ?? ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ step: 1 }}
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                value3From: parseNullableInteger(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.value3From}
                                        helperText={divisionErrors.value3From}
                                    />
                                    <TextField
                                        label="Value3To"
                                        type="number"
                                        value={DivisionModalItem.value3To ?? ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ step: 1 }}
                                        onChange={(e) =>
                                            setDivisionModalItem({
                                                ...DivisionModalItem,
                                                value3To: parseNullableInteger(e.target.value)
                                            })
                                        }
                                        error={!!divisionErrors.value3To}
                                        helperText={divisionErrors.value3To}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={DivisionModalItem.isCustom ?? false}
                                                onChange={(e) => setDivisionModalItem({ ...DivisionModalItem, isCustom: e.target.checked })}
                                            />
                                        }
                                        label="isCustom"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={DivisionModalItem.isNull ?? false}
                                                onChange={(e) => setDivisionModalItem({ ...DivisionModalItem, isNull: e.target.checked })}
                                            />
                                        }
                                        label="isNull"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsDivisionModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleDivisionModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isCompetitionTypeModalOpen}
                                onClose={() => setIsCompetitionTypeModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit CompetitionType</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Description"
                                        value={CompetitionTypeModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, name: e.target.value })}
                                        error={!!competitionTypeErrors.name}
                                        helperText={competitionTypeDataQuery.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={CompetitionTypeModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, abbr: e.target.value })}
                                        error={!!competitionTypeDataQuery.abbr}
                                        helperText={competitionTypeDataQuery.abbr}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={CompetitionTypeModalItem.position || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, position: Number(e.target.value) })
                                        }
                                        error={!!competitionTypeErrors.position}
                                        helperText={competitionTypeErrors.position}
                                    />
                                    <TextField
                                        label="Comments"
                                        value={CompetitionTypeModalItem.comments || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        onChange={(e) =>
                                            setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, comments: e.target.value })
                                        }
                                        error={!!competitionTypeErrors.comments}
                                        helperText={competitionTypeErrors.comments}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={CompetitionTypeModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsCompetitionTypeModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleCompetitionTypeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>

                <SimpleAccordion
                    title={<Typography variant="h6">Application Type Product Ages</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>Application Type Product Ages</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddApplicationTypeProductAge,
                                    onDelete: handleDeleteApplicationTypeProductAge,
                                    onSave: handleApplicationTypeProductAges,
                                    isChanged: isApplicationTypeProductAgesChanged
                                })}
                            </div>
                            <div>
                                <FlexGrid
                                    initialized={(flex) => initializeApplicationTypeProductAges(flex)}
                                    className="explorer-grid"
                                    itemsSource={applicationTypeProductAgesList.filter((item) => !item.isDeleted)}
                                    autoSizeMode={1}
                                    headersVisibility={3}
                                    alternatingRowStep={0}
                                >
                                    <FlexGridColumn header="Application Type" binding="applicationTypeTitle" width={220} isReadOnly={true} />
                                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="productServiceTitle" width={240} isReadOnly={true} />
                                    <FlexGridColumn header="Από Ηλικία" binding="fromAge" width={120} dataType="Number" align="left" />
                                    <FlexGridColumn header="Έως Ηλικία" binding="toAge" width={120} dataType="Number" align="left" />
                                    <FlexGridColumn header="Τιμή" binding="unitPrice" width={120} dataType="Number" align="left" />
                                    <FlexGridColumn header="Έγκυρο από" binding="validFrom" width={160} dataType="String" align="left" />
                                    <FlexGridColumn header="Έγκυρο έως" binding="validTo" width={160} dataType="String" align="left" />
                                    <FlexGridColumn header="Ενεργό" binding="isActive" width={100} dataType="Boolean" align="center" />
                                </FlexGrid>
                            </div>
                            <Dialog
                                open={isAppTypeProductAgesModalOpen}
                                onClose={() => setIsAppTypeProductAgesModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Application Type Product Age</DialogTitle>
                                <DialogContent dividers>
                                    <FormControl fullWidth margin="normal" error={!!appTypeProductAgesErrors.applicationTypeId}>
                                        <InputLabel id="app-type-product-age-application-type-label">Application Type</InputLabel>
                                        <Select
                                            labelId="app-type-product-age-application-type-label"
                                            value={appTypeProductAgesModalItem.applicationTypeId || ''}
                                            label="Application Type"
                                            onChange={(e) =>
                                                setAppTypeProductAgesModalItem({
                                                    ...appTypeProductAgesModalItem,
                                                    applicationTypeId: e.target.value
                                                })
                                            }
                                        >
                                            {applicationTypeList.map((type) => (
                                                <MenuItem key={type.id} value={type.id}>
                                                    {type.description || type.abbr}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductAgesErrors.applicationTypeId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductAgesErrors.applicationTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!appTypeProductAgesErrors.productServiceId}>
                                        <InputLabel id="app-type-product-age-product-service-label">Product Service</InputLabel>
                                        <Select
                                            labelId="app-type-product-age-product-service-label"
                                            value={appTypeProductAgesModalItem.productServiceId || ''}
                                            label="Product Service"
                                            onChange={(e) =>
                                                setAppTypeProductAgesModalItem({
                                                    ...appTypeProductAgesModalItem,
                                                    productServiceId: e.target.value
                                                })
                                            }
                                        >
                                            {productServicesList.map((ps) => (
                                                <MenuItem key={ps.id} value={ps.id}>
                                                    {ps.description || ps.code}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductAgesErrors.productServiceId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductAgesErrors.productServiceId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Από Ηλικία"
                                        type="number"
                                        value={appTypeProductAgesModalItem.fromAge ?? ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ step: 1 }}
                                        onChange={(e) =>
                                            setAppTypeProductAgesModalItem({
                                                ...appTypeProductAgesModalItem,
                                                fromAge: parseNullableInteger(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductAgesErrors.fromAge}
                                        helperText={appTypeProductAgesErrors.fromAge}
                                    />
                                    <TextField
                                        label="Έως Ηλικία"
                                        type="number"
                                        value={appTypeProductAgesModalItem.toAge ?? ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ step: 1 }}
                                        onChange={(e) =>
                                            setAppTypeProductAgesModalItem({
                                                ...appTypeProductAgesModalItem,
                                                toAge: parseNullableInteger(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductAgesErrors.toAge}
                                        helperText={appTypeProductAgesErrors.toAge}
                                    />
                                    <TextField
                                        label="Τιμή"
                                        type="number"
                                        value={appTypeProductAgesModalItem.unitPrice ?? ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAppTypeProductAgesModalItem({
                                                ...appTypeProductAgesModalItem,
                                                unitPrice: parseNullableNumber(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductAgesErrors.unitPrice}
                                        helperText={appTypeProductAgesErrors.unitPrice}
                                    />
                                    <TextField
                                        label="Έγκυρο από"
                                        type="date"
                                        value={appTypeProductAgesModalItem.validFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                            setAppTypeProductAgesModalItem({
                                                ...appTypeProductAgesModalItem,
                                                validFrom: e.target.value
                                            })
                                        }
                                        error={!!appTypeProductAgesErrors.validFrom}
                                        helperText={appTypeProductAgesErrors.validFrom}
                                    />
                                    <TextField
                                        label="Έγκυρο έως"
                                        type="date"
                                        value={appTypeProductAgesModalItem.validTo || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                            setAppTypeProductAgesModalItem({
                                                ...appTypeProductAgesModalItem,
                                                validTo: e.target.value
                                            })
                                        }
                                        error={!!appTypeProductAgesErrors.validTo}
                                        helperText={appTypeProductAgesErrors.validTo}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={appTypeProductAgesModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setAppTypeProductAgesModalItem({
                                                        ...appTypeProductAgesModalItem,
                                                        isActive: e.target.checked
                                                    })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsAppTypeProductAgesModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleApplicationTypeProductAgeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">Application Type Product Services</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>Application Type Product Services</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddApplicationTypeProductService,
                                    onDelete: handleDeleteApplicationTypeProductService,
                                    onSave: handleSaveApplicationTypeProductServices,
                                    isChanged: isApplicationTypeProductServicesChanged
                                })}
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeApplicationTypeProductServices(flex)}
                                className="explorer-grid"
                                itemsSource={applicationTypeProductServicesList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Application Type" binding="applicationTypeTitle" width="*" isReadOnly={true} />
                                <FlexGridColumn header="Product Service" binding="productServiceTitle" width="*" isReadOnly={true} />
                                <FlexGridColumn header="Unit Price" binding="unitPrice" width="*" />
                                <FlexGridColumn header="VAT %" binding="vatPerc" width="*" />
                                <FlexGridColumn header="Valid From" binding="validFrom" width="*" />
                                <FlexGridColumn header="Valid To" binding="validTo" width="*" />
                                <FlexGridColumn header="Trans Type" binding="transTypeId" width="*" />
                                <FlexGridColumn header="Status" binding="isActive" width="*" />
                            </FlexGrid>
                            <Dialog
                                open={isAppTypeProductServicesModalOpen}
                                onClose={() => setIsAppTypeProductServicesModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Application Type Product Service</DialogTitle>
                                <DialogContent dividers>
                                    <FormControl fullWidth margin="normal" error={!!appTypeProductServicesErrors.applicationTypeId}>
                                        <InputLabel id="app-type-label">Application Type</InputLabel>
                                        <Select
                                            labelId="app-type-label"
                                            value={appTypeProductServicesModalItem.applicationTypeId || ''}
                                            onChange={(e) =>
                                                setAppTypeProductServicesModalItem({
                                                    ...appTypeProductServicesModalItem,
                                                    applicationTypeId: e.target.value
                                                })
                                            }
                                        >
                                            {applicationTypeList.map((type) => (
                                                <MenuItem key={type.id} value={type.id}>
                                                    {type.description || type.abbr}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductServicesErrors.applicationTypeId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductServicesErrors.applicationTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth margin="normal" error={!!appTypeProductServicesErrors.productServiceId}>
                                        <InputLabel id="product-service-label">Product Service</InputLabel>
                                        <Select
                                            labelId="product-service-label"
                                            value={appTypeProductServicesModalItem.productServiceId || ''}
                                            onChange={(e) =>
                                                setAppTypeProductServicesModalItem({
                                                    ...appTypeProductServicesModalItem,
                                                    productServiceId: e.target.value
                                                })
                                            }
                                        >
                                            {productServicesList.map((ps) => (
                                                <MenuItem key={ps.id} value={ps.id}>
                                                    {ps.description || ps.code}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductServicesErrors.productServiceId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductServicesErrors.productServiceId}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    <TextField
                                        label="Unit Price"
                                        type="number"
                                        value={appTypeProductServicesModalItem.unitPrice || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                unitPrice: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductServicesErrors.unitPrice}
                                        helperText={appTypeProductServicesErrors.unitPrice}
                                    />

                                    <TextField
                                        label="VAT %"
                                        type="number"
                                        value={appTypeProductServicesModalItem.vatPerc || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                vatPerc: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductServicesErrors.vatPerc}
                                        helperText={appTypeProductServicesErrors.vatPerc}
                                    />

                                    <TextField
                                        label="Valid From"
                                        type="date"
                                        value={appTypeProductServicesModalItem.validFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                validFrom: e.target.value
                                            })
                                        }
                                    />

                                    <TextField
                                        label="Valid To"
                                        type="date"
                                        value={appTypeProductServicesModalItem.validTo || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                validTo: e.target.value
                                            })
                                        }
                                        error={!!appTypeProductServicesErrors.validTo}
                                        helperText={appTypeProductServicesErrors.validTo}
                                    />

                                    <FormControl fullWidth margin="normal" error={!!appTypeProductServicesErrors.transTypeId}>
                                        <InputLabel id="trans-type-label">Transaction Type</InputLabel>
                                        <Select
                                            labelId="trans-type-label"
                                            value={appTypeProductServicesModalItem.transTypeId || ''}
                                            onChange={(e) =>
                                                setAppTypeProductServicesModalItem({
                                                    ...appTypeProductServicesModalItem,
                                                    transTypeId: e.target.value
                                                })
                                            }
                                        >
                                            {transactionTypesList.map((t) => (
                                                <MenuItem key={t.id} value={t.id}>
                                                    {t.description || t.abbr || 'Unnamed'}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductServicesErrors.transTypeId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductServicesErrors.transTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={appTypeProductServicesModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setAppTypeProductServicesModalItem({
                                                        ...appTypeProductServicesModalItem,
                                                        isActive: e.target.checked
                                                    })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsAppTypeProductServicesModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleApplicationTypeProductServiceModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">Product Services</Typography>}
                    content={
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>Product Services</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddProductService,
                                    onDelete: handleDeleteProductService,
                                    onSave: handleSaveProductServices,
                                    isChanged: isProductServicesChanged
                                })}
                            </div>

                            <FlexGrid
                                initialized={(flex) => initializeProductServices(flex)}
                                className="explorer-grid"
                                itemsSource={productServicesList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Description" binding="description" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Code" binding="code" width="*" />
                                <FlexGridColumn header="Unit Price" binding="unitPrice" width="*" />
                                <FlexGridColumn header="VAT %" binding="vatPerc" width="*" />
                                <FlexGridColumn header="Position" binding="position" width="*" />
                                <FlexGridColumn header="Active" binding="isActive" width="*" />
                                <FlexGridColumn header="Unique Per Entity" binding="isUniquePerEntity" width="*" />
                            </FlexGrid>

                            <Dialog
                                open={isProductServicesModalOpen}
                                onClose={() => setIsProductServicesModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Product Service</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Description"
                                        value={productServicesModalItem.description || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({ ...productServicesModalItem, description: e.target.value })
                                        }
                                        error={!!productServicesErrors.description}
                                        helperText={productServicesErrors.description}
                                    />

                                    <TextField
                                        label="Abbreviation"
                                        value={productServicesModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setProductServicesModalItem({ ...productServicesModalItem, abbr: e.target.value })}
                                        error={!!productServicesErrors.abbr}
                                        helperText={productServicesErrors.abbr}
                                    />

                                    <TextField
                                        label="Code"
                                        value={productServicesModalItem.code || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setProductServicesModalItem({ ...productServicesModalItem, code: e.target.value })}
                                    />

                                    <TextField
                                        label="Unit Price"
                                        type="number"
                                        value={productServicesModalItem.unitPrice || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({
                                                ...productServicesModalItem,
                                                unitPrice: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!productServicesErrors.unitPrice}
                                        helperText={productServicesErrors.unitPrice}
                                    />

                                    <TextField
                                        label="VAT %"
                                        type="number"
                                        value={productServicesModalItem.vatPerc || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({
                                                ...productServicesModalItem,
                                                vatPerc: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!productServicesErrors.vatPerc}
                                        helperText={productServicesErrors.vatPerc}
                                    />

                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={productServicesModalItem.position || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({ ...productServicesModalItem, position: parseInt(e.target.value) })
                                        }
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={productServicesModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setProductServicesModalItem({ ...productServicesModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={productServicesModalItem.isUniquePerEntity ?? false}
                                                onChange={(e) =>
                                                    setProductServicesModalItem({
                                                        ...productServicesModalItem,
                                                        isUniquePerEntity: e.target.checked
                                                    })
                                                }
                                            />
                                        }
                                        label="Unique Per Entity"
                                    />
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsProductServicesModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleProductServicesModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK File Types</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK File Types</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddFileType,
                                    onDelete: handleDeleteFileType,
                                    onSave: handleSaveFileTypes,
                                    isChanged: isFileTypesChanged
                                })}
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeFileTypes(flex)}
                                className="explorer-grid"
                                itemsSource={fileTypesList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Code" binding="code" width="*" />
                                <FlexGridColumn header="Description" binding="descr" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Issued By" binding="lblIssuedBy" width="*" />
                                <FlexGridColumn header="Comments" binding="lblComments" width="*" />
                                <FlexGridColumn header="Status" binding="isActive" width="*" />
                            </FlexGrid>
                            <Dialog open={isFileTypeModalOpen} onClose={() => setIsFileTypeModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Add/Edit File Type</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Code"
                                        value={fileTypeModalItem.code || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, code: e.target.value })}
                                        error={!!fileTypesErrors.code}
                                        helperText={fileTypesErrors.code}
                                    />
                                    <TextField
                                        label="Descr"
                                        value={fileTypeModalItem.descr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, descr: e.target.value })}
                                        error={!!fileTypesErrors.descr}
                                        helperText={fileTypesErrors.descr}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={fileTypeModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, abbr: e.target.value })}
                                        error={!!fileTypesErrors.abbr}
                                        helperText={fileTypesErrors.abbr}
                                    />
                                    <TextField
                                        label="DataKey"
                                        value={fileTypeModalItem.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, dataKey: e.target.value })}
                                        error={!!fileTypesErrors.dataKey}
                                        helperText={fileTypesErrors.dataKey}
                                    />
                                    <TextField
                                        label="TableRef"
                                        value={fileTypeModalItem.tableRef || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, tableRef: e.target.value })}
                                        error={!!fileTypesErrors.tableRef}
                                        helperText={fileTypesErrors.tableRef}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={fileTypeModalItem.position || 1}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, position: Number(e.target.value) })}
                                        error={!!fileTypesErrors.position}
                                        helperText={fileTypesErrors.position}
                                    />
                                    <TextField
                                        label="Lbl Issued By"
                                        value={fileTypeModalItem.lblIssuedBy || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, lblIssuedBy: e.target.value })}
                                        error={!!fileTypesErrors.lblIssuedBy}
                                        helperText={fileTypesErrors.lblIssuedBy}
                                    />
                                    <TextField
                                        label="Lbl Comments"
                                        value={fileTypeModalItem.lblComments || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, lblComments: e.target.value })}
                                        error={!!fileTypesErrors.lblComments}
                                        helperText={fileTypesErrors.lblComments}
                                    />
                                    <TextField
                                        label="Templates"
                                        value={fileTypeModalItem.templates || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, templates: e.target.value })}
                                        error={!!fileTypesErrors.templates}
                                        helperText={fileTypesErrors.templates}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={fileTypeModalItem.copyToPF ?? false}
                                                onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, copyToPF: e.target.checked })}
                                            />
                                        }
                                        label="Copy To PF"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={fileTypeModalItem.isActive ?? true}
                                                onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsFileTypeModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleFileTypeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Optional Answers</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Optional Answers</h2>
                                {renderLookupToolbar({
                                    onAdd: handleAddOptionalAnswer,
                                    onDelete: handleDeleteOptionalAnswer,
                                    onSave: handleSaveOptionalAnswers,
                                    isChanged: isOptionalAnswerChanged
                                })}
                            </div>
                            <FlexGrid
                                initialized={initializeOptionalAnswers}
                                className="explorer-grid"
                                itemsSource={optionalAnswersList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Question" binding="questionTitle" width="*" isReadOnly={true} />
                                <FlexGridColumn header="Title" binding="title" width="*" />
                                <FlexGridColumn header="Correct" binding="isCorrect" width="*" />
                                <FlexGridColumn header="Position" binding="position" width="*" />
                                <FlexGridColumn header="Active" binding="isActive" width="*" />
                                <FlexGridColumn header="Disabled" binding="isDisabled" width="*" />
                            </FlexGrid>
                            <Dialog
                                open={isOptionalAnswerModalOpen}
                                onClose={() => setIsOptionalAnswerModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Optional Answer</DialogTitle>
                                <DialogContent dividers>
                                    {optionalAnswerModalItem && (
                                        <>
                                            <FormControl fullWidth margin="normal" error={!!optionalAnswerErrors.questionId}>
                                                <InputLabel id="question-id-label">Question</InputLabel>
                                                <Select
                                                    labelId="question-id-label"
                                                    id="question-id"
                                                    value={optionalAnswerModalItem.questionId || ''}
                                                    label="Question"
                                                    onChange={(e) =>
                                                        setOptionalAnswerModalItem({
                                                            ...optionalAnswerModalItem,
                                                            questionId: e.target.value
                                                        })
                                                    }
                                                >
                                                    {questionList
                                                        .filter((q) => !q.isDeleted)
                                                        .map((q) => (
                                                            <MenuItem key={q.id} value={q.id}>
                                                                {q.title || q.code || 'Untitled'}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                                {optionalAnswerErrors.questionId && (
                                                    <Typography variant="caption" color="error">
                                                        {optionalAnswerErrors.questionId}
                                                    </Typography>
                                                )}
                                            </FormControl>

                                            <TextField
                                                label="Title"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.title || ''}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({ ...optionalAnswerModalItem, title: e.target.value })
                                                }
                                                error={!!optionalAnswerErrors.title}
                                                helperText={optionalAnswerErrors.title}
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={optionalAnswerModalItem.isCorrect ?? false}
                                                        onChange={(e) =>
                                                            setOptionalAnswerModalItem({
                                                                ...optionalAnswerModalItem,
                                                                isCorrect: e.target.checked
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Is Correct"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={optionalAnswerModalItem.isActive ?? true}
                                                        onChange={(e) =>
                                                            setOptionalAnswerModalItem({
                                                                ...optionalAnswerModalItem,
                                                                isActive: e.target.checked
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Active"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={optionalAnswerModalItem.isDisabled ?? false}
                                                        onChange={(e) =>
                                                            setOptionalAnswerModalItem({
                                                                ...optionalAnswerModalItem,
                                                                isDisabled: e.target.checked
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Disabled"
                                            />

                                            <TextField
                                                label="Position"
                                                type="number"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.position ?? 0}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({
                                                        ...optionalAnswerModalItem,
                                                        position: Number(e.target.value)
                                                    })
                                                }
                                                error={!!optionalAnswerErrors.position}
                                                helperText={optionalAnswerErrors.position}
                                            />

                                            <TextField
                                                label="Optional Answer Code 1"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.optionalAnswerCode1 || ''}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({
                                                        ...optionalAnswerModalItem,
                                                        optionalAnswerCode1: e.target.value
                                                    })
                                                }
                                                error={!!optionalAnswerErrors.optionalAnswerCode1}
                                                helperText={optionalAnswerErrors.optionalAnswerCode1}
                                            />

                                            <TextField
                                                label="Optional Answer Code 2"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.optionalAnswerCode2 || ''}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({
                                                        ...optionalAnswerModalItem,
                                                        optionalAnswerCode2: e.target.value
                                                    })
                                                }
                                                error={!!optionalAnswerErrors.optionalAnswerCode2}
                                                helperText={optionalAnswerErrors.optionalAnswerCode2}
                                            />
                                        </>
                                    )}
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsOptionalAnswerModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleOptionalAnswerModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <div>
                    <SimpleAccordion
                        title={<Typography variant="h6">LK Question</Typography>}
                        content={
                            <>
                                {' '}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}
                                >
                                    <h2 style={{ margin: 0 }}>LK Question</h2>
                                    {renderLookupToolbar({
                                        onAdd: handleAddQuestion,
                                        onDelete: handleDeleteQuestion,
                                        onSave: handleSaveQuestions,
                                        isChanged: isQuestionChanged
                                    })}
                                </div>
                                <FlexGrid
                                    initialized={initializeQuestions}
                                    className="explorer-grid"
                                    itemsSource={questionList.filter((q) => !q.isDeleted)}
                                    autoSizeMode={1}
                                    headersVisibility={3}
                                    alternatingRowStep={0}
                                >
                                    <FlexGridColumn header="Code" binding="code" width="*" />
                                    <FlexGridColumn header="Title" binding="title" width="*" />
                                    <FlexGridColumn header="TypeId" binding="typeId" width="*" />
                                    <FlexGridColumn header="Multiple" binding="acceptsMultipleAnswers" width="*" />
                                    <FlexGridColumn header="Integer" binding="isInteger" width="*" />
                                </FlexGrid>
                                <Dialog open={isQuestionModalOpen} onClose={() => setIsQuestionModalOpen(false)} maxWidth="sm" fullWidth>
                                    <DialogTitle>Add/Edit Question</DialogTitle>
                                    <DialogContent dividers>
                                        <TextField
                                            label="Code"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.code || ''}
                                            onChange={(e) => setQuestionModalItem({ ...questionModalItem, code: e.target.value })}
                                            error={!!questionErrors.code}
                                            helperText={questionErrors.code}
                                        />

                                        <TextField
                                            label="Title"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.title || ''}
                                            onChange={(e) => setQuestionModalItem({ ...questionModalItem, title: e.target.value })}
                                            error={!!questionErrors.title}
                                            helperText={questionErrors.title}
                                        />

                                        <TextField
                                            label="Description"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.description || ''}
                                            onChange={(e) => setQuestionModalItem({ ...questionModalItem, description: e.target.value })}
                                            error={!!questionErrors.description}
                                            helperText={questionErrors.description}
                                        />

                                        <FormControl fullWidth margin="normal" error={!!questionErrors.typeId}>
                                            <InputLabel id="type-id-label">Question Type</InputLabel>
                                            <Select
                                                labelId="type-id-label"
                                                value={questionModalItem.typeId || ''}
                                                onChange={(e) =>
                                                    setQuestionModalItem({
                                                        ...questionModalItem,
                                                        typeId: e.target.value
                                                    })
                                                }
                                                label="Question Type"
                                            >
                                                {Array.isArray(questionTypes) &&
                                                    questionTypes.map((type) => (
                                                        <MenuItem key={type.id} value={type.id}>
                                                            {type.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            {questionErrors.typeId && (
                                                <Typography variant="caption" color="error">
                                                    {questionErrors.typeId}
                                                </Typography>
                                            )}
                                        </FormControl>

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={questionModalItem.acceptsMultipleAnswers || false}
                                                    onChange={(e) =>
                                                        setQuestionModalItem({
                                                            ...questionModalItem,
                                                            acceptsMultipleAnswers: e.target.checked
                                                        })
                                                    }
                                                />
                                            }
                                            label="Multiple Answers"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={questionModalItem.isInteger || false}
                                                    onChange={(e) =>
                                                        setQuestionModalItem({ ...questionModalItem, isInteger: e.target.checked })
                                                    }
                                                />
                                            }
                                            label="Integer Answer"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={questionModalItem.hasCorrectAnswers || false}
                                                    onChange={(e) =>
                                                        setQuestionModalItem({ ...questionModalItem, hasCorrectAnswers: e.target.checked })
                                                    }
                                                />
                                            }
                                            label="Has Correct Answers"
                                        />

                                        <TextField
                                            label="Limit Low"
                                            type="number"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.limitLow ?? ''}
                                            onChange={(e) =>
                                                setQuestionModalItem({ ...questionModalItem, limitLow: parseFloat(e.target.value) })
                                            }
                                            error={!!questionErrors.limitLow}
                                            helperText={questionErrors.limitLow}
                                        />

                                        <TextField
                                            label="Limit High"
                                            type="number"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.limitHigh ?? ''}
                                            onChange={(e) =>
                                                setQuestionModalItem({ ...questionModalItem, limitHigh: parseFloat(e.target.value) })
                                            }
                                            error={!!questionErrors.limitHigh}
                                            helperText={questionErrors.limitHigh}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => setIsQuestionModalOpen(false)}>Cancel</Button>
                                        <Button variant="contained" onClick={handleQuestionModalSave}>
                                            Save
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </>
                        }
                    />
                </div>

                <Dialog open={lookupDeleteDialog.open} onClose={closeLookupDeleteDialog} maxWidth="xs" fullWidth>
                    <DialogTitle>{t('Delete', { defaultValue: 'Διαγραφή' })}</DialogTitle>
                    <DialogContent>
                        <Typography>{lookupDeleteDialog.message}</Typography>
                        {lookupDeleteDialog.itemLabel && (
                            <Typography sx={{ mt: 2, color: 'text.secondary' }}>{lookupDeleteDialog.itemLabel}</Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeLookupDeleteDialog}>{t('Cancel', { defaultValue: 'Ακύρωση' })}</Button>
                        <Button variant="contained" color="error" onClick={handleLookupDeleteConfirm} startIcon={<DeleteIcon />}>
                            {t('Delete', { defaultValue: 'Διαγραφή' })}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={!!lookupErrorMessage} onClose={() => setLookupErrorMessage('')} maxWidth="sm" fullWidth>
                    <DialogContent sx={{ display: 'flex', gap: 3, alignItems: 'center', py: 4 }}>
                        <HighlightOffIcon color="error" sx={{ fontSize: 56, flex: '0 0 auto' }} />
                        <Typography sx={{ whiteSpace: 'pre-line' }}>{lookupErrorMessage}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={() => setLookupErrorMessage('')}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={isConfirmOpen} onClose={() => handleConfirmResponse(false)}>
                    <DialogTitle>{t('Update', { defaultValue: 'Μεταβολή' })}</DialogTitle>
                    <DialogContent>
                        {t('UpdateChecklistQuestion', {
                            defaultValue: 'Θέλετε σίγουρα να αποθηκεύσετε τις αλλαγές;'
                        })}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleConfirmResponse(false)}>{t('No', { defaultValue: 'Όχι' })}</Button>
                        <Button variant="contained" onClick={() => handleConfirmResponse(true)}>
                            {t('Yes', { defaultValue: 'Ναι' })}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        ),
        error: <p>error</p>
    }[(eventDataQuery.status, seasonDataQuery.status, applicationTypeProductAgesDataQuery.status)];
};

export default ChecklistScreen;
